module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.6.0.0.box.672.256.390.62.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.6.0.0.box.672.256.390.62.q.100"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.6.1.0.box.178.362.1379.2080.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "font-variant": "small-caps"
    },
    attrs: {
      "id": "para.6.1.0.box.184.362.332.86.q.50"
    }
  }, [_vm._v("4:33 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.6.1.1.box.178.633.1378.540.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.0.0"
    }
  }), _vm._v("It's ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Difficult ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("For ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Him ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("To ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("See ")]), _vm._v("Louisiana in it anymore. The red highways have become arteries, the slight blue curves of rivers veins, the levels of brown contour intervals like fine wrinkles, the skin blotched with cities like graying bruises. Then, in the map's very bottom right corner the blue of the Gulf becomes dark, so dark the depth it conveys frightens him. It seems as though this is where the foot is headed, where it will scrape off the muck hanging from its sole —the southern parishes built of swamp, from New Orleans to New Iberia.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.6.1.2.box.178.1202.1378.236.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.1.0"
    }
  }), _vm._v("It's next to his bed, the only thing he has on his bedroom walls. It's about three feet tall and wide and, thanks to the United States Geological Survey, contains the most accurate geographical information humanly possible of our state, our state alone.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.6.1.3.box.178.1454.1379.611.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.2.0"
    }
  }), _vm._v("For years now, when sleep will not come, he has traveled around and around the state with his eyes, wondering what people are doing, dreaming right then in all those pinprick black dots joined by the crooked red roads thin as hair. He imagines the peop"), _c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.3.0"
    }
  }), _vm._v("le there on his map, about the size of atoms, living their days, moving in circles, alone and together, bumping into one another in patternless rhythm. He wants to know them, these places, with more than his fingertip. He wants to grow them to life-size proportions, hear them, feel their light, smell their seasons, taste their waters, know them so well they in turn know him.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.6.1.4.box.178.2082.1378.297.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.4.0"
    }
  }), _vm._v("And so he has tried in the past years to touch as many of these places as possible, driven through them, slept in them, listened to them, ate, drank and breathed in them, but they are too many, and there is too little time for anything but a fleeting grasp at them, never any real hold, and never time enough for them to hold him.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA5.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.6.1.5.box.228.2395.1326.47.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA5.w.2.5.0"
    }
  }), _vm._v("Now, this morning, below the framed map are seven boxes piled"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.7.1.0.box.177.255.1371.351.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.0.0"
    }
  }), _vm._v("\nhigh with words telling him exactly what is happening in virtually every one of those dots, on every contour, every bayou, river, and lake. And so begins the long process of culling through submissions for "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Louisiana ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Words. ")]), _vm._v("In these boxes, now in this book, are true stories, voices of generations, life and death, joy and sorrow, man and nature inside our state's borders.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.7.1.0.box.177.255.1374.2185.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.7.1.1.box.178.635.1371.666.q.60"
    }
  }, [_vm._v("After "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("America ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("24/7 ")]), _vm._v("was published, so was a similar book for every state. Like others before them, done the world over, these \"day in the life\" books, while necessary and remarkable in their own way, were mostly photographs. A picture can say a thousand words —an expression someone had to put into words, of course —but the right words can portray a million pictures, ones far more complex and meaningful than can ever be caught through the photographer's lens and squashed onto a silver halide negative or megabytes of pixels. Never before had a book sought to capture a single day in a state through short written pieces by different writers. Would it work?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.7.1.2.box.179.1326.1371.296.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.2.0"
    }
  }), _vm._v("Writing a true minute so that others can feel it, getting in so close they become a new person for a page, is quite different from snapping a photograph from a distance. Anyone can point a camera, take a thousand images, capture one that speaks to us—but to form a thousand words that brought together ring truth, to only have one shot?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.7.1.3.box.179.1638.1371.424.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.3.0"
    }
  }), _vm._v("Calls for submissions went out to every newspaper in the state (who knew we had well over a hundred?) and every public library, college, Web site, writing group, radio station, you name it, as well as international writing publications. The basic guidelines were fairly simple: In one page or less, write about one minute, anytime, anywhere in Louisiana. The response, in both quality and quantity, was tremendous, and many worthy pieces had to be excluded.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA6.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.7.1.4.box.179.2078.1372.362.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA6.w.1.4.0"
    }
  }), _vm._v("Though hurricanes inextricably frame our views of the world now, we asked that submissions not focus on them. Those minutes will continue to be told elsewhere. The words \"Katrina\" and \"Rita\" do not appear in a single story, yet some of these works presage not only the floods —such as the second piece —but the hope with which we've met our greatest challenge.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.8.1.0.box.177.254.1371.2189.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.0.box.177.254.1370.237.q.70"
    }
  }, [_vm._v("The stories' themes reveal our state in all its simplicity and complexity. And the writers range from MFA professors to people putting pencil to paper for the first time since grade school (and one who is in grade school).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.1.box.177.507.1371.299.q.60"
    }
  }, [_vm._v("Selecting the best writing would have been too easy. Selecting writing that best conveys the spirits of our state is another matter. Many didn't know how to write their first story any other way than to simply tell it. Their style is bare because there is none. And their every word wrenches truth from their minute.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.2.box.177.823.1371.363.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.2.0"
    }
  }), _vm._v("There is no time to blink when you read these pieces. You might miss the magic. Some minutes are written after decades of intimate knowledge of a subject; others depict something their writers observed only briefly, something they will never see again. But all are firsthand observations. Many of the pieces are autobiographical, yet most writers refer to themselves as we would — in the third person.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.3.box.177.1203.1371.487.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.3.0"
    }
  }), _vm._v("There are conflicting perspectives on these pages, some that many people will not agree with, yet it would be dishonest to our state's nature to exclude them. As everywhere, ignorance rears its head in our state, and it will be shown here. And too, these pieces are not free of other \"faults\" that buck trends of modern literature. For instance, there's plenty of sentimentality, but only when the sentiment is honest to the story's, and state's, nature, rather than a romanticized notion of our place in the world.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.4.box.177.1707.1371.359.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.4.0"
    }
  }), _vm._v("The pieces run chronologically from dawn to dawn, spanning one single day, any day, merging past and present. They range from frost to swelter, from a man telling the story behind a picture of him taken in 1926 to the present day. Change and preservation, hand in hand, sweep across these pages beneath fleeting strokes of sun and sister stars. They are testament to what was, is, and always will be.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.5.box.177.2082.1371.228.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.5.0"
    }
  }), _vm._v("Of course, we cannot exhaust every last element of our state between these covers. But together these minutes provide a mosaic that conveys a whole Louisiana to the disparate regions within our state, to the outside world, and to the future.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.6.box.178.2333.1370.110.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.6.0"
    }
  }), _vm._v("A minute. The time it takes to defrost a couple of slices of bread in the microwave. The time it takes for your $200 high heels to sink"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.9.1.0.box.178.262.1370.363.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.0.0"
    }
  }), _vm._v("\ninto the mud around your mother's grave. The time it takes an old yardman whose name you never knew to save your young daughter from being kidnapped. Time it takes a levee to rupture. Teach your grandchildren to listen to the giant live oaks beneath which you grew up. To learn hate from men in white hoods. To bury a sparrow in the Mississippi.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.9.1.0.box.178.262.1370.553.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.9.1.1.box.179.642.1368.173.q.50"
    }
  }, [_vm._v("And so he stands in his bedroom, facing the map on his wall, 4:33 a.m., above these pages, these words stacked below him. Now they are yours, ours.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.9.2.0.box.1273.894.276.42.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.9.2.0.box.1273.894.276.42.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.2.0.0"
    }
  }), _vm._v("— ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Joshua ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Clark ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.10.0.0.box.404.600.876.484.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "198%",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.10.0.0.box.404.600.876.484.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.0.0"
    }
  }), _vm._v("LOUISIANA IN WORDS")]), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.4.0.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.6.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.7.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.8.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.9.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.10.0.0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.11.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.12.0.0"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.13.0.0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.11.0.0.box.184.90.1470.2630.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.14.0.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.15.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0005.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.15.0.0.1"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.16.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.12.0.0.box.0.114.1472.2544.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.17.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic][subsumed]",
      "src": "data/content-0006.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.17.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.13.1.0.box.178.696.1369.465.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.13.1.0.box.180.696.330.88.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.18.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.19.0.0"
    }
  }), _vm._v("4:49 A.M.")]), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.20.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.20.1.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.13.1.1.box.178.876.1369.285.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.20.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.20.3.0"
    }
  }), _vm._v("Moon ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.20.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.20.5.0"
    }
  }), _vm._v("Filters ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.20.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.21.0.0"
    }
  }), _vm._v("Through ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.22.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.23.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.24.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.0.0"
    }
  }), _vm._v("Reeds, ")]), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.10.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.10.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.10.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.10.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.10.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.10.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.10.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.11.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.12.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.13.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.13.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.13.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.13.3.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.13.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.13.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.13.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.13.7.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.13.8.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.13.9.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.2.0.0"
    }
  }), _vm._v("mulberries, and moss — silver as sunstained water. The egret alights, child angel, among wild blue irises. The alligator, cunning, skims the viscous swamp, opens its jaws, snaps shut. One white wing, blood tinged and torn, rocks, rests, in a small cove.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.2.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.3.0.0"
    }
  }), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.13.2.0.box.1178.1253.370.47.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.13.2.0.box.1178.1253.370.47.q.80"
    }
  }, [_vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Beverly ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Matherne ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.14.1.0.box.177.264.1372.2053.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.14.1.0.box.180.264.326.88.q.70"
    }
  }, [_vm._v("5:00 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.14.1.1.box.177.443.1370.300.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.2.0.0"
    }
  }), _vm._v("You "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Want ")]), _vm._v("TO CATCH FISH, you have to be there when they're hungry. You fish the marshes for catfish, speckled trout, and redfish as soon as it's daylight. This Saturday that means having your boat ready to be slung into the bayou by an old crane (one dollar per foot of boat length) at Hopedale down in St. Bernard Parish by 5:00 a.m.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.2.box.177.759.1372.363.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.2.1.0"
    }
  }), _vm._v("There's a line of vehicles, mostly pickup trucks, with trailered boats behind, waiting their turn at the launch. The darkness somehow makes the humidity worse, and the mosquitoes swarm out of the tall reeds, biting and zinging. Your turn comes, you tie your boat to the dock out of the way of the next boat to be launched, and hurry back to park your truck and empty trailer in the weeds by the road.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.3.box.178.1138.1371.491.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.2.2.0"
    }
  }), _vm._v("Careful to make only a small wake, you idle quietly down Bayou La Loutre past the sleeping houses on the east bank, make the final left turn, and pour on the coal until you intersect the Mississippi River Gulf Outlet. They call it \"MR. GO.\" You make a sweeping left turn around the green, triangular channel marker. A half-mile or so and you turn right into an oil company canal heading into the marsh. Straight as a die, the canal spawns a hundred bayous on either side. Your only guide to fishing success is your instinct.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.4.box.178.1644.1371.673.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.2.3.0"
    }
  }), _vm._v("So you anchor a hundred yards down a side bayou, the marsh grass and little trees all around you, butterflies waving madly and white egrets working the mud banks. Then, all of a sudden, a really strange thing happens. Your boat drops like an elevator and lands on the bottom. Unheard and unseen, a gigantic freighter has slid down MR. GO behind you. Its passing displaces so much water in the confined channels that all the water in your bayou is momentarily sucked out. You're looking at the mud bottom, the crab traps, plastic bags, beer cans, and other trash lying there. You spin around in time to see the huge brown hull disappearing toward the Gulf. As quickly as it drained, the water rises again and you bob to the surface. It's as though it never happened.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.14.2.0.box.1230.2396.319.33.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.14.2.0.box.1230.2396.319.33.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.3.0.0"
    }
  }), _vm._v("— "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Graham ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Clarke ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.15.1.0.box.177.270.1372.2173.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.15.1.0.box.180.270.308.86.q.50"
    }
  }, [_vm._v("5:51A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.15.1.1.box.177.447.1371.426.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("On ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("His ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Hands ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("And ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Knees, ")]), _vm._v("Emile strains to see past the early morning curtain of gray mist in Andrus Cove. The light fog shifts around him in rhythm with the air, thicker here than there, then, shifting again, gives first little visibility and then only a little more. The wintry droplets of wetness settle against his face. But Papa Anatole has taught him that a good hunter makes no extra motions, so he shivers as the dew runs down his cheeks and drips from his chin.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.1.2.box.178.890.1371.349.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.2.1.0"
    }
  }), _vm._v("He holds the old man's twenty-gauge shotgun lightly against the ground. He has learned about noise too. The rice field was harvested only a week before, leaving a blanket of stubby stalks. If he moves too fast, the crush of rice stubble will give him away. So he inches forward, crawling slowly and making sure not to get dirt in the end of the barrel.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.1.3.box.177.1267.1371.233.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.2.2.0"
    }
  }), _vm._v("His heart pounds. In moments, he'll break through the fog and catch sight of them. He hears them moving slowly about; muttering, wakened by the just breaking dawn. The impulsive air again disturbs the fog and there they are.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.1.4.box.178.1516.1371.359.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.2.3.0"
    }
  }), _vm._v("Emile freezes. There are six, no seven. They feel safe because none of them keeps watch for the others. His forefinger finds the safety button near the trigger guard. He's ready. Moving as slowly as a watched snake, he lies down, eases the gun up to his line of sight, and braces it against his shoulder. He aims. The sight falls upon the closest one's head and he fires.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.1.5.box.178.1892.1371.298.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.2.4.0"
    }
  }), _vm._v("The sharp blast echoes through the fog, shocking the morning awake, followed immediately by an ocean-wave rush of thousands of Canadian geese thrashing the air. Emile is quickly to his knees and fires again into a bird-blackened sky. Feathers fly as one of the big birds whirls upside down and drops.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.1.6.box.178.2207.1371.236.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.2.5.0"
    }
  }), _vm._v("Though he has two geese for the gumbo, he stands and aims above the fog for a third shot. But as he aims, he finds that the sun has touched the horizon and torched the sky. Rays of bright orange fan out between gray Gulf-of-Mexico clouds scattered across the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.16.1.0.box.178.257.1370.426.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.0.0"
    }
  }), _vm._v("\nindigo heavens. Rising across the brilliantly colored background are a thousand black and white geese, now in row after row of "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("V ")]), _vm._v("formations, in chorus, calling out their hopes, their fears, their celebration, and their mockery of the hunter below. The gigantic formation turns in unison, swings south, as though they are all controlled by one mind. Who knows, Emile thinks. Maybe they are. He smiles and slowly lowers his gun.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA15"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.16.1.0.box.178.257.1370.426.q.60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.16.2.0.box.1131.762.419.34.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.16.2.0.box.1131.762.419.34.q.60"
    }
  }, [_vm._v("— "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Edward ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("G. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Gauthier ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA16"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.17.1.0.box.179.266.1378.2172.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.17.1.0.box.180.266.324.88.q.50"
    }
  }, [_vm._v("5:59 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.17.1.1.box.179.443.1371.238.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Dawn ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("June ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Light ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Pries ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Its ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Fingers ")]), _vm._v("through the passing storm clouds, pushes its way through the heavy rain as it thunders on the metal roof, demanding we hear its music while leaning on the rails of the porch.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.2.box.181.694.1370.169.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.2.1.0"
    }
  }), _vm._v("Beards of daddy long legs sit quiet, unmoving, listening, watching, waiting for the light, attached to the shelter of this cedar porch roof, here, on the shore north of Pontchartrain.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.3.box.182.883.1370.163.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.2.2.0"
    }
  }), _vm._v("The rain pounds, careens into the deep drainage ditches, travels down to the Tchefuncte River. It is rain of perhaps the intensity that Noah knew.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.4.box.182.1071.1371.362.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.2.3.0"
    }
  }), _vm._v("Twelve feet from the drainage ditches there are tiny stacked mounds. No matter how hard you look you won't see the crawdads that inhabit them. Don't bother to think of fetching your "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("piegnon ")]), _vm._v("or strings; they're too tiny to be after with spear and tie. There is not enough water in the red clay soil to grow them big enough for gumbo pots.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.5.box.233.1449.409.47.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.2.4.0"
    }
  }), _vm._v("The seconds tick by.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.6.box.184.1509.1370.112.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.2.5.0"
    }
  }), _vm._v("The urge to light is now stronger than the lessening energy of the storm clouds moving east.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.7.box.184.1635.1371.226.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.2.6.0"
    }
  }), _vm._v("Tiny squirrels emerge from the deep brown, gnarled, lovingly protective ark of live oaks that were first breaking the soil and clay with their roots a century ago when the big quake rocked San Francisco.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.8.box.234.1887.1064.48.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.2.7.0"
    }
  }), _vm._v("The stray gray cat leaves its refuge under the house.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.9.box.185.1948.1370.175.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.2.8.0"
    }
  }), _vm._v("The neighbor dogs bark their morning greetings down the muddied, potholed, dirt road from one to the other; Great Dane and Mastiff, to Red Hound, to just plain mixed varieties of whatever.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.10.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.10.box.185.2138.1372.300.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.2.9.0"
    }
  }), _vm._v("Light gentles away the thinning clouds; ignores the now distant lightning; is deaf to the hollowed thunder, then bursts into brilliant hot yellow, glowing here, dappling there through live oak leaves, steaming them, whispering "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("wake ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("up ")]), _vm._v("through the blooming gardenias, sago fronds, dark greens of camellias.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA17"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.18.1.0.box.177.254.1372.996.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.0.box.177.254.1369.111.q.60"
    }
  }, [_vm._v("The sky shouts blue, impatient now, splits a light rainbow through the sun-sparkled residual slow soft rain.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.1.box.177.383.1371.109.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.1.0"
    }
  }), _vm._v("Cloying steam rises from the grass, drips off your fingers, while meandering steam tendrils wend their way through the pinewoods.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.2.box.177.507.1370.175.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.2.0"
    }
  }), _vm._v("Scores of the nine hundred acres of herbivores at Global Wildlife, tiny and huge, longhaired and short, ever hungry for visitors, add their music to the post-storm morning symphony.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.3.box.177.697.1371.175.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.3.0"
    }
  }), _vm._v("Logging trucks rumble down the highway that flexes and moans under the heavy weight of overloaded flatbeds longer than the living rooms of most of us.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.4.box.178.887.1370.111.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.4.0"
    }
  }), _vm._v("Redbirds, robins, blue jays, woodpeckers, crows give throat to song.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.5.box.228.1014.902.47.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.5.0"
    }
  }), _vm._v("Daddy long legs stretch, flutter their beards.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.6.box.177.1077.1372.173.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.6.0"
    }
  }), _vm._v("The new morning light glistens the myriad greens into silvers and gold; disperses the heavy gardenia scent from blooming bushes with ten-foot spans onto a gentle breeze.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.18.2.0.box.1274.1330.276.46.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.18.2.0.box.1274.1330.276.46.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Remy ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Benoit ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA18"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.19.1.0.box.177.250.1375.2053.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.19.1.0.box.184.250.326.90.q.50"
    }
  }, [_vm._v("6:40 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.19.1.1.box.179.433.1373.913.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("In ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Morning's ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("First ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Light, ")]), _vm._v("the cypress-timbered huts are dim shapes, shrouded in mist rolling in from Cane River Lake and settling over the plantation's grounds and, beyond, its flat fields and pecan orchards. A door creaks on its iron hinges, and a rush of warmth from the big house escapes as Sherman steps onto the back porch to begin his chores. \"Thirty-three degrees is cold for Natchitoches this late in February,\" he sighs, picturing the countless branches he must pick up before noon, when tourists would start to trickle in. Boxed in a gray corduroy jacket, Sherman stoops to lift the basket, big as a cauldron, to his hip, his hands like paddles in brown leather gardening gloves. In the distance, a wood duck whistles, a mourning dove coos. The only other sound is the \"cluck, cluck\" of Betty the hen as she rustles nearby through the ragged stalks of the lone banana tree, brown and withered now, save for a single, erect, green shoot at its center.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.1.2.box.177.1375.1373.928.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.2.1.0"
    }
  }), _vm._v("Sherman turns to survey the day's territory, and he catches his breath: the breaking light touches with gold a vast pink-and-white quilt of fallen blossoms covering every inch of earth. \"That early spring shower last night rained petals,\" Sherman whispers, as he whirls to gaze at the towering Japanese magnolias, still laden with cuplike flowers, magenta-stained on the outside, creamy white on the inside, perfuming the misty air with a delicate, orchidlike fragrance. \"A lower heaven,\" Sherman pronounces, as he spots Betty, now roosting on a branch of a great live oak, fringed with green Resurrection fern. Next to her is a Brown Leghorn rooster. Sherman has named this barnyard pimp Lyle Saxon after the writer who once lived here at Melrose Plantation and wrote all his books about Louisiana in the mud-and-moss Yucca House. \"Well, Betty,\" Sherman says with a wink, \"looks like all that strutting Lyle did around here lately was for a reason.\" Betty clucks, Lyle inches closer, and the sun rises.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.19.2.0.box.1226.2384.323.46.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.19.2.0.box.1226.2384.323.46.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.3.0.0"
    }
  }), _vm._v("— "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Chance ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Harvey ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA19"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.20.1.0.box.177.266.1374.1616.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.20.1.0.box.180.266.324.88.q.70"
    }
  }, [_vm._v("7:30 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.20.1.1.box.177.444.1372.429.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Back ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Roads ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Between ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Crowley ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("And ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Lafayette ")]), _c('a', {
    attrs: {
      "id": "GBS.PA19"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.2.0.0"
    }
  }), _vm._v("run through farm country. People use these roads to avoid the heavy traffic on Interstate 10 or U.S. Highway 90. This morning, a car traveling toward Lafayette on one of these roads makes a right turn and . . . stops. The driver, a middle-aged man, opens the door, gets out, and leans on the front fender, mesmerized by the scene that h"), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.3.0.0"
    }
  }), _vm._v("as caught his eye.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.2.box.178.888.1373.426.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.4.0.0"
    }
  }), _vm._v("On the right side of the road, the sun is just high enough to highlight a large saucer of water wrapped around by a levee and, beyond that, another levee-wrapped saucer of water. The scene is repeated — water, levee, water, levee—all the way to a horizon defined by small scrub trees, shrubs, and weeds, their soft grays and greens and tans melding and blending into the not-yet-bright-blue of the sky.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.3.box.228.1330.665.47.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.4.1.0"
    }
  }), _vm._v("The man's eyes search the scene.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.4.box.229.1393.344.35.q.70"
    }
  }, [_vm._v("He moves closer.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.5.box.179.1456.1371.112.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.4.2.0"
    }
  }), _vm._v("He smells the air, catching the odors of dust, mud, water, and decaying vegetation.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.6.box.229.1584.1311.47.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.4.3.0"
    }
  }), _vm._v("He feels the heat, the humidity making the air heavy and sticky.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.7.box.179.1646.1372.236.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.4.4.0"
    }
  }), _vm._v("For the length of several heartbeats, Time seems to warp and displace the Now, the Present, in his mind. For just a moment, he wonders: Is this a South Vietnamese rice paddy ... or a South Louisiana crawfish pond?")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.20.2.0.box.1237.1961.315.33.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.20.2.0.box.1237.1961.315.33.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.5.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Erlene ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Stewart ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.21.1.0.box.177.262.1373.1610.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.21.1.0.box.182.262.328.88.q.60"
    }
  }, [_vm._v("8:00 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.21.1.1.box.177.443.1373.298.q.50"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("\"dharma ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Bums\" ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.0.0"
    }
  }), _vm._v("Reincarnated! ")]), _vm._v("Wine spodee-odee and all that jazz. But this is a still life after having taken the road again on our literary "), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.1.0"
    }
  }), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("wanderjahr ")]), _vm._v("of the South. Asleep in the car it's \"Smokin' Joe\" Cote, Lenny, and me. Took the wrong turn out of Awlins Town, Highway #23, the \"Belle Chasse\" to Nowhere, Louisiana.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.2.box.179.758.1371.174.q.60"
    }
  }, [_vm._v("No canals, no St. Mark's, no Hotel Flora. But Venice, all right. Venice, Louisiana. There's only the cathedral of the wide morning sky stretching over the Gulf of Mexico. . . .")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.3.box.179.949.1370.173.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.2.0"
    }
  }), _vm._v("Parked on road's shoulder we raise our heads from the seats to see a jumble of untended shrimp boats half-submerged and slanted in pearly light, the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Donna ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Marie, ")]), _vm._v("the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Captain ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Peter, ")]), _vm._v("the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Night ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Star. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.4.box.178.1137.1372.358.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.3.0"
    }
  }), _vm._v("Damn. It's eighty-four degrees already. Beer cans that chased last night's Jim Beam are now making tinny floor chimes when I move my feet to rise, one shoulder at a time. Air creeps into our rental car windows scented with marsh salt, close, silky, silty soft. Low cloud cover, and the radio lady's voice switched to \"On\" drifting moodily. Len mutters, \"We're movin' light but doin' dark.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.5.box.178.1510.1372.288.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.4.0"
    }
  }), _vm._v("Rubbing eyes, I glance to the page of my journal with roadside signs noted. There's Scoop's Seafood Market, Miss Anne's Lounge, the Party Tavern. That sounds mighty good. There's also the signboard reading \"Intrepid Fabrications.\" It tells us what we already know. Writers need life to imitate art.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.6.box.228.1825.1258.47.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.2.5.0"
    }
  }), _vm._v("The Baptist church sign warns: "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"It ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sure ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hot, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("but ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hell's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hotter.\" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.21.2.0.box.1232.1954.318.45.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.21.2.0.box.1232.1954.318.45.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.3.0.0"
    }
  }), _vm._v("- ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Lou ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("McKinney ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA21"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.22.1.0.box.177.266.1375.2176.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.22.1.0.box.180.266.294.90.q.50"
    }
  }, [_vm._v("8:11A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.22.1.1.box.177.444.1370.113.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.0.0"
    }
  }), _vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Resident ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Beat ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Poet ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Of ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Orleans ")]), _vm._v("is sitting on the stoop of a small green flat on Orleans Street in the French Quarter.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.2.box.177.571.1371.238.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.1.0"
    }
  }), _vm._v("His bloodshot eyes are worshiping the sunrise; his mind is trying to pardon itself from the pool of alcohol it's swimming in; his mouth is dragging on a Newport cigarette all the way to the cotton nub. The sun has not completely settled in the fresh morning sky.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.3.box.179.823.1370.363.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.2.0"
    }
  }), _vm._v("He screams an indictment against American culture. He is tall and Irish, with cheekbone-length blond hair and black artsy/intellectual glasses. He is wearing a tuxedo with finely polished black patent leather shoes. He is wearing a green athletic fleece sweatshirt over his tuxedo top with a bib of his own vomit down the center of the fleece. Green fleece streaked with yellow mucus and dried alcohol.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.4.box.179.1202.1371.302.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.3.0"
    }
  }), _vm._v("His hands are black from tar and mud and probably crawling in the gutter. The sun rises above the Catholic church in the east "), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.4.0"
    }
  }), _vm._v("and his eyes become illuminated. They are dime-sized sunbursts — phoenixes, devils. His pupils fluctuate in diameter, incongruently, even in the direct sunlight. He is drunk, and probably high on something else —not life.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.5.box.180.1519.1371.363.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.5.0"
    }
  }), _vm._v("He laments the loss of true freedom and curses the displacement of American values and the absurdity of war. He does so in a poem, which he recites in a bubbly fever, stopping after every line to massage his stomach and catch his breath. His ambitions are to conform his work to the existing works of Ginsberg, so he says. His poetry is more Ginsberg than an evolving conformity.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.6.box.181.1896.1371.359.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.6.0"
    }
  }), _vm._v("He screams indictments against American culture to cars that pass on the street and tells a tall, slim black woman who struts past him she is f—ing cool. The poet likes black women but he hates black men, so he says. He shows the world —which won't listen to him —his scarred hands: deep gashes on his knuckles. The shadow from the crucifix atop the Catholic church is slashing his face in two.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.7.box.182.2270.1370.172.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.7.0"
    }
  }), _vm._v("\"I had to beat young black men that were robbing old ladies. That's f—in' humanity,\" he gasps. Young black men are exploiting the structure of freedom in America, according to the poet.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.23.1.0.box.177.250.1372.994.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.0.box.177.250.1371.300.q.60"
    }
  }, [_vm._v("He recites some more of his (Ginsberg's) poetry. He ends his splenetic poem by raising his arms and mock-cocking a twelve-gauge shotgun and blasting the sun. This black-hearted bard wants to demolish America; he wants to blow it all away, but New Orleans is safe. New Orleans is not America, so says the poet.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.1.box.179.566.1368.174.q.50"
    }
  }, [_vm._v("\"This is the f—ing foundation, man,\" he rants, as he stomps his foot clumsily on the brick-and-cement sidewalk. \"The f—ing foundation.\" The sidewalk he is stomping on is cracked.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.2.box.178.755.1370.238.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.2.0"
    }
  }), _vm._v("He insists on reciting love poems to lovely couples. He serenades them with the words as they walk by. The poet is persistent. The lovers are apprehensive of his drunken conviction, so says the quickening rhythm of their shoes slapping the concrete.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.3.box.178.1008.1371.236.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.3.0"
    }
  }), _vm._v("The lovers are gone. The sun is higher now. It's so bright the poet can no longer see the Catholic church. It's burning right into his eyes. He is reciting the words of love to the lovers who cannot hear him. The words are beautiful. They are T. S. Eliot's.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.23.2.0.box.1207.1322.343.44.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.23.2.0.box.1207.1322.343.44.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cody ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Whetstone ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA23"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.24.1.0.box.177.262.1373.2118.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.24.1.0.box.180.262.324.90.q.70"
    }
  }, [_vm._v("9:00 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.24.1.1.box.177.445.1370.679.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.2.0.0"
    }
  }), _vm._v("A "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Plume ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Of ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Spoken ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Words ")]), _vm._v("trails from the mouths of three women walking down an icy mud road. \"You know we're nuts to be out here bird watching in weather this cold. In two days it will probably be in the sixties.\" \"Yeah, but we would miss all the good winter birds. Hey, look, look.\" One points to the top of a leafless hackberry tree. Against the china blue sky, a flock of birds settles on the branches and begins feeding on the small fruit. \"Cedar waxwings,\" one lady murmurs and they all nod in agreement, their binoculars pressing tight against their eyes. They watch the small sleek yellow and brown birds flutter about, a splotch of red on the wings like wax and black-masked crested heads identifying them.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.2.box.178.1140.1370.173.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.2.1.0"
    }
  }), _vm._v("All are so wrapped up in the sighting, none notices an old man has joined their group. \"What you looking at?\" he says. They all gasp and jump in unison.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.3.box.179.1330.1369.111.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.2.2.0"
    }
  }), _vm._v("Although he doesn't laugh, his shoulders shake in obvious delight. He repeats, \"What you see?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.4.box.179.1457.1369.108.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.2.3.0"
    }
  }), _vm._v("Recovering her composure, one lady answers this common question asked of birders. She identifies the birds as cedar waxwings.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.5.box.178.1582.1370.110.q.50"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.2.4.0"
    }
  }), _vm._v("\"Mais ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("oui, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("drier, ")]), _vm._v("make a good gumbo, yeah,\" he says, his eyes watching the women with interest.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.6.box.229.1708.1119.35.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.2.5.0"
    }
  }), _vm._v("All turn horrified faces to him. \"You would eat them?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.7.box.229.1772.1248.47.q.60"
    }
  }, [_vm._v("\"Well, sure,\" he says. \"When you hungry, you eat anything.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.8.box.178.1835.1371.232.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.2.6.0"
    }
  }), _vm._v("They continue watching the birds sitting in orderly rows in the hackberry and listen to their barely audible high-pitched \"zzzzzz.\" The man seems to be able to see the birds with his old eyes just about as well as they can with their expensive optics.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.9.box.178.2083.1372.297.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.2.7.0"
    }
  }), _vm._v("One lady's mind drifts to a long time ago when this area of Terrebonne Parish was isolated both by culture and geography, especially in the rare hard cold spells. She imagines the man as a young father, a table full of small mouths to feed, a pot of steaming gumbo perfuming a small room, a gumbo full of tiny bones.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.25.1.0.box.177.248.1370.237.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.0.box.177.248.1369.111.q.60"
    }
  }, [_vm._v("As the women turn to leave, one lady says, \"You know, it's illegal to shoot them now.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.1.box.177.376.1370.109.q.60"
    }
  }, [_vm._v("He nudges her lightly with his elbow. Unsmiling, his eyes twinkle in his wrinkled brown face. \"Good eating,\" he says.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.25.2.0.box.1251.564.294.35.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.25.2.0.box.1251.564.294.35.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Patricia ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Allen ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA25"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.26.1.0.box.177.262.1374.2175.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.26.1.0.box.182.262.310.90.q.50"
    }
  }, [_vm._v("9:21A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.26.1.1.box.179.443.1372.549.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Monday ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Mornings ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Art ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Kendrick ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Loads ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Up ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("His ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Pirogue ")]), _c('a', {
    attrs: {
      "id": "GBS.PA25"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.2.0.0"
    }
  }), _vm._v("with the dead birds and paddles out in the bayou. He owns a cockfighting ring in Bogalusa, on the Pearl River, the dividing line between Louisiana and Mississippi. Every Sunday during fighting season the crowds gather for this cultural and family event. Grown men walk around with their fighting cocks stroking and talking to them — six-foot, 300-pound rednecks cradling roosters like babies. Four-inch razor blades are strapped to the cocks' feet and they are thrown in to fight for their lives.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.2.box.177.1008.1373.928.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.2.1.0"
    }
  }), _vm._v("On game day, things get started pretty early. The cooking begins about 6:00 a.m. There's Double D sausage and eggs on the griddle. There's a huge pot of Community Dark Roast brewing. The coffee helps wake up and warm the crowd. The various space heaters throughout the barn are not enough to take the chill out of the huge aircraft hangar. It only truly warms up later in the morning, when over two hundred people crowd the bleachers: young and old, men and women, participants and spectators. The bleachers consist of two-by-twelves cut into rough stairs. There are old, salvaged church pews on one side of the ring. Their location and their cushions make them the good seats. You have to get up pretty early for those. The air is cold, the seats are cold, and it smells like damp wood and dung. The winter air is dry and a wind blows up dust from the dirt floor that lies beneath the large ring in the center of the bleachers and the smaller rings off to the side.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.3.box.177.1952.1372.359.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.2.2.0"
    }
  }), _vm._v("Once the round begins, so does the betting. From one side of the ring a man in overalls and a plaid shirt yells, \"I've got twenty dollars on the red bird.\" This is matched with a shout of \"I'll take that twenty dollars on the white bird,\" from a man with a Skoal ring on his back pocket. Excitement is high. Kids are eating hotdogs and speculating with their friends or parents about who will win.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.4.box.178.2327.1369.110.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.2.3.0"
    }
  }), _vm._v("The ref watches up close and the handlers stand aside. One bird sticks its razor clear through the other bird's neck. The ref yells,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.27.1.0.box.177.256.1369.236.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.0.0"
    }
  }), _vm._v("\n\"Handle your birds!\" The handlers quickly grab their birds. The handler of the injured bird sticks its whole head in his mouth and sucks the blood from his dying bird's lungs. He spits out the blood and sends the revived cock back out to fight.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA26"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.27.1.0.box.177.256.1372.928.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.1.box.178.508.1371.486.q.60"
    }
  }, [_vm._v("Once both birds are injured the excitement of the fight slows and the cocks are moved to a smaller side ring. Those who are invested in the fight follow, those who are not anxiously await the next fight. A smaller side ring is set aside for the dead cocks. These birds, only a while ago caressed by their handlers, are now forgotten trash, tossed aside to be disposed of later. Art once rescued a cock from the death pit that wasn't quite dead; it turned out to be quite the fighter.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.2.box.178.1009.1370.175.q.60"
    }
  }, [_vm._v("Now, the day after, Art is alone, paddling out in the bayou, his pirogue loaded with the dead birds. The alligators look forward to these Monday mornings.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.27.2.0.box.1273.1263.277.47.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.27.2.0.box.1273.1263.277.47.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cathy ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Setter ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA27"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.28.1.0.box.177.262.1372.2054.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.28.1.0.box.182.262.324.90.q.60"
    }
  }, [_vm._v("9:27 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.28.1.1.box.177.444.1372.1872.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.2.0.0"
    }
  }), _vm._v("9:27 "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("A.m. ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Splays ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Out ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Like ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Eternity ")]), _vm._v("in August-Metairie, Louisiana. The sun-so-far-above drones down slow, blazing its white heat in long low waves that bounce even slower off the patchwork of concrete and asphalt stretching out behind the old Oldsmobile dealership on Veterans. All the colors of new shimmer off the cars like Mardi Gras beads glitter on parade days, but slowed with summertime sun. Dirty blue smoke curls up in paper-thin ribbons, anchored at the ashy-red end of a cigarette and the hand holding it draws back, through the millions of water-molecule seas. The seas hold so close together in the heavy humid now, riding waves of sunlight and absorbing thousands of chemicals in the dirty blue smoke. That hand holding belongs to the boy-becoming-a-carsalesMan, waiting for the morning meeting at 9:30. Catching a smoke, waiting for the morning meeting, becoming a carsalesMan in the suburbs of New Orleans, and "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("what-a-wonderful-life ")]), _vm._v("he thinks, slowly though, like the long low waves of heat and the curling dirty blue smoke, curling down the nicotine into his lungs with a long low drag. It hits him right away, the dizziness of the deep drag he feels at 9:27 in the morning in August-Metairie, in Louisiana. Waving sideways are sounds of the autobay, rippling millions of water-molecule seas, the dat-dat-dat of the air drill, the thick Cajun accent of a mechanic without the substance of his words filtering through. Cajun tone and tenor ride those waves with their own special style —peaked out with a lulling swampy cadence, and the air drill draws in sharp exclamation points at every unknown-sentence-ending. Ashy-red anchor heats the hand holding, and fingers quick-flick what's left of the cigarette toward all those new colors. Selling summertime in the suburbs of New Orleans in August isn't anything the boy-becoming-a-carsalesMan wants to meet about as the minute hand of the clock overhead points him onward to 9:28 a.m.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.28.2.0.box.1117.2396.430.42.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.28.2.0.box.1117.2396.430.42.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.3.0.0"
    }
  }), _vm._v("-Joshua ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Leran ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Holmes ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA28"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.29.1.0.box.177.272.1372.2174.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.29.1.0.box.180.272.324.88.q.70"
    }
  }, [_vm._v("9:30 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.29.1.1.box.177.452.1372.551.q.60"
    }
  }, [_vm._v("A "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Cottage ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Industry ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Of ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Life ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("On ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Water ")]), _c('a', {
    attrs: {
      "id": "GBS.PA28"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.2.0.0"
    }
  }), _vm._v("appears sparingly on Highway 82: hull welders, custom propellers, dry docks, until the body of water becomes consistent, matures to an open span evident for miles. The last land, just before this, is Intracoastal City, surrounded by fields of sugarcane, rice, and crawfish. Decaying barns and storage buildings punctuate the otherwise occupied expanse. The muddied fields are a dense batter of earth and water, incredulously dark. Billet harvesters reap the cane in unison. A hedge of crane peck and rest in the prolific earth.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.2.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.2.box.178.1019.1371.547.q.60"
    }
  }, [_vm._v("Tethers to civilization disappear once the boat enters the marsh. The waterways are marked simply with symbols, colors, and occasional crawfish buoys. The GPS crackles indeterminately; the noise from the engine is ceaseless. The occasional boater waves from an opposite direction. The boat enters and exits a maze of hidden passages until the ranger station at the Fearman Refuge appears, a manmade island occupied by a solitary ranger assigned to manage and patrol the entire marsh. American and Louisiana state flags slouch on a pole.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.3.box.178.1583.1371.863.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.2.2.0"
    }
  }), _vm._v("Brother slows the boat to a crawl and maneuvers to the south end of the ranger station to a pier separating the marsh reserve from the public. Another boat is already tied to the pier; a man with a shrimp net is positioning himself to cast. Brother docks, cuts the engine, and begins the business of tying turkey necks to tent stakes with waterproof nylon twine. He prepares an entire packet of necks, climbs onto the dock, and begins dropping them into the water. Within seconds he tugs the cord of a sunken neck and checks for resistance. He grabs a net from the boat, returns to the line, and begins to reel the cord and the neck onto the dock until a crab appears. He gingerly places the net underneath the crab and gives it a shake until the crab releases. With his right leg he reaches over to the boat, kicks open an industrial-size cooler with the name L. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Bernard ")]), _vm._v("sharpied on the lid, and drops in the first of many blue crab."), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.30.1.0.box.177.253.1371.111.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.0.0"
    }
  }), _vm._v("\nTranslucent jellyfish caught by previous boaters slick the dock; they slurp into the water with a swipe from Brother's foot.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA29"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.30.1.0.box.177.253.1373.931.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.1.1.box.178.381.1372.803.q.60"
    }
  }, [_vm._v("The lead weights from the shrimper's net give a dull thump against the soaked boards. \"Det's sum nice creb,\" says the man in affected Cajun syncopation, noting the crab fighting inside the cooler. Brother wipes his hands on his trousers and watches the man. \"See,\" says the Cajun, \"you give it 'nough slack. Hold de net with de left and open de rest with de right. Now, when you t'row it you'll want to twirl it with your wrist. Imagine you dancing with your girl and she twirls around de floor and her skirt lifts up so you can see underneath.\" The Cajun follows his own instruction and throws the slack net, which bursts into an uninterrupted circle inches before breaking the surface of the water. Brother smiles, kneels onto the soaking pier, gives a tug to each line for the next blue crab to appear.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.30.2.0.box.1238.1265.311.33.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.30.2.0.box.1238.1265.311.33.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Gabriel ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Gomez ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA30"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.31.1.0.box.178.258.1373.1861.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.31.1.0.box.180.258.324.88.q.60"
    }
  }, [_vm._v("9:37 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.31.1.1.box.178.440.1372.296.q.60"
    }
  }, [_vm._v("A "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Young ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Couple ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Emerges ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("From ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Piney ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Woods ")]), _c('a', {
    attrs: {
      "id": "GBS.PA30"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.0.0"
    }
  }), _vm._v("bounded on one side by a small pond and the other by a wide cow pasture. The pond is still, and the cows shuffle lazily about, heads bent down, lipping for grass. The couple holds hands as they approach a little house with a screened-in porch that stretches its entire length.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.2.box.178.753.1372.175.q.60"
    }
  }, [_vm._v("An older man stands near the house with a holstered pistol snug to his waist. He waves at the young woman, who waves back. \"I was checking the cows,\" he says. \"Saw the car.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.3.box.178.944.1373.608.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.2.0"
    }
  }), _vm._v("The young woman introduces the older man, explaining that he lives up the road a bit, near Bunkie, and watches out for her father's farm while they're in New Orleans. While the men shake hands, an armadillo trundles by, oddly oblivious to the nearby people. The caretaker spots it, lifts the pistol from his waist, clicks the safety, and fires. The sound seems strangely muffled in the quiet morning, as if the thick, wet air dulls the gun's pop, and the armadillo tumbles over without a noise, though it writhes and flails its claws in the air. \"Your father around?\" asks the caretaker, wandering over to the squirming animal.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.4.box.229.1569.931.46.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.3.0"
    }
  }), _vm._v("\"No,\" she says, \"it's just us for the weekend.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.5.box.178.1632.1372.110.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.4.0"
    }
  }), _vm._v("He nods, picks the armadillo up by its tail, and smashes it against a tree. It stops wriggling. \"Well, tell him hello for me.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.6.box.229.1757.338.47.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.5.0"
    }
  }), _vm._v("\"Sure,\" she says.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.7.box.179.1821.1371.159.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.6.0"
    }
  }), _vm._v("The caretaker walks off, carrying the dead armadillo. The body dribbles blood, though not nearly as much as the young man thinks it should.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.8.box.229.2009.698.35.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.2.7.0"
    }
  }), _vm._v("\"What the hell was that?\" he asks.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.9.box.228.2072.767.47.q.60"
    }
  }, [_vm._v("She shrugs. \"They're pests,\" she says.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.31.2.0.box.1289.2198.261.34.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.31.2.0.box.1289.2198.261.34.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.3.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Dale ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Hrebik ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA31"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.32.1.0.box.177.262.1374.2117.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.32.1.0.box.182.262.324.90.q.50"
    }
  }, [_vm._v("9:47 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.32.1.1.box.178.442.1372.172.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.2.0.0"
    }
  }), _vm._v("They ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Don't ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Know ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Her ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Name, ")]), _vm._v("but they know that some of the people who talk to her get to leave. They know they want to leave, and they hope she can help.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.2.box.229.631.650.48.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.2.1.0"
    }
  }), _vm._v("\"Teacher! Hey, teacher! Please!\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.3.box.178.695.1373.427.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.2.2.0"
    }
  }), _vm._v("Her eyes scan the pod. There are no bars at Caddo Correctional Center, only metal doors, rectangular windows, eyes. It's impossibly loud, and she is wondering how such loud voices can come from such small eyes. She hears the desperation in the voices and mistakes it for urgency or boredom or some strange form of flattery. When she is gone, the deputy will hit the intercom button and announce the consequence for yelling.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.4.box.177.1137.1373.362.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.2.3.0"
    }
  }), _vm._v("She counts the number of footlockers outside the door. Four inmates are on suicide watch. Inside, she knows, those inmates are dressed in blue. There is an awkward moment when she realizes that she too is wearing blue and she stops midstep. The voices coming from behind her stop. Perhaps they think she will turn around. She quickly resumes her pace, and the calls continue.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.5.box.229.1517.942.47.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.2.4.0"
    }
  }), _vm._v("\"Teacher! Everything you need to know! Me!\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.6.box.177.1579.1373.363.q.60"
    }
  }, [_vm._v("The interviews, the m"), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.2.5.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.2.6.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.2.7.0"
    }
  }), _vm._v("edical gowns, the eyes have changed her. For her, blue is not the color of a summer sky or a baby blanket. Blue is a bed sheet turned noose, a footlocker beside the phrase "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("blunt ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("head ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("trauma, ")]), _vm._v("a ten-degree temperature drop. Last week she heard about a woman who tried to kill herself by chugging balled pages of a Gideon's Bible. It seems to her like the punch-line of a bad joke.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.7.box.177.1959.1372.281.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.2.8.0"
    }
  }), _vm._v("Instead of thinking about this, she focuses on the task ahead. She's counting her steps. The deputy beside her reminds her of the time. She's tallying her questions, her steps, the number of times she hears the word \"teacher.\" She's nearing his cell. The intercom clicks on and then announces.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.8.box.229.2268.853.48.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.2.9.0"
    }
  }), _vm._v("\"192476, uh, 93098 ... you got company!\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.9.box.228.2331.1321.48.q.70"
    }
  }, [_vm._v("They left the rookie manning the station. It's unusual for her to"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.33.1.0.box.177.255.1371.109.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.0.0"
    }
  }), _vm._v("\nconduct interviews in the pod, but Mr. Timer only got out of the infirmary yesterday.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA32"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.33.1.0.box.177.255.1373.1303.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.1.box.178.380.1371.108.q.70"
    }
  }, [_vm._v("\"He's still not walking so good,\" the deputy says. \"But that Timer is still ticking.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.2.box.178.505.1371.426.q.60"
    }
  }, [_vm._v("The joke is a bad one since they both know that the one thing that Mr. Timer doesn't have is time. One of the tumors they removed from his liver last week was the size of a small child's fist. Outside of his cell, she bends down to look in through the serving slot. The proximity of his eyes startles her. In the last few weeks the whites of his eyes had faded into a muted yellow. Today that yellow is bright with interruptions of red.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.3.box.177.949.1372.173.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.3.0"
    }
  }), _vm._v("Dried spit sits in the corners of his mouth as he extends a shaking hand through the serving slot toward her. When she shakes it, she feels his raised veins. This is the first time they have ever touched.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.4.box.177.1138.1373.420.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.4.0"
    }
  }), _vm._v("She pulls back her hand faster than she means to and watches as he pulls the photos of his family out of his Bible. When his photos are in his hand, he is ready to begin. This is his routine. Neither of them knows that this is the last time they will see each other, but they both have a hunch. When he starts to cry, she forgets her questions and the number of steps. She notices that the voices calling for her attention are gone. Only the eyes remain.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.33.2.0.box.1183.1638.363.45.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.33.2.0.box.1183.1638.363.45.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.2.0.0"
    }
  }), _vm._v("— "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Sunday ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Angleton ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA33"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.34.1.0.box.177.264.1373.2242.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.34.1.0.box.180.264.326.88.q.50"
    }
  }, [_vm._v("9:52 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.34.1.1.box.178.443.1372.868.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.2.0.0"
    }
  }), _vm._v("\"This ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Is ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("It.\" ")]), _vm._v("The old man gestures to his right by tapping the window on the passenger side four times in rapid-fire succession with his middle finger. \"Just pull in alongside the van.\" The window tapping begins again. The Gray Ghost, an ancient Mercury Grand Marquis, aches and groans as it bounces toward the carport, unsuccessfully dodging holes the size of bean pots as it makes its way down a driveway lined with oyster shells. The side panels of the van come into full view, a rolling advertisement for Slick's Photography and Guns (\"We'll shoot ya' one way or the other\") eye level as the occupants emerge from the Ghost. First the old man hoists himself up and out of the car and then, tentatively, a strapping Illinois farm boy, square-jawed and too tall to be from around here, emerges from the driver's side, the old man's son-in-law, making his first trip to South Louisiana, to Thibodaux, to be exact.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.1.2.box.178.1327.1372.426.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.2.1.0"
    }
  }), _vm._v("They're going out on the water today, and Slick is the old man's fishing partner in a place where every man has a fishing partner, where fishing partner (or hunting buddy, depending on the season) is actually what men call each other instead of \"friends.\" Today they're headed down to Pointe au Chien, but it's already midmoming and already mid-June and, at this rate, they'll be putting in just as the reds and specks are sinking down low in search of the quiet and the cool.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.1.3.box.177.1770.1373.736.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.2.2.0"
    }
  }), _vm._v("The car doors shut, one after the other, with a satisfying "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("thwack. ")]), _vm._v("The guys toss their tackle boxes in the joeboat and head toward Slick's house, a rambling cypress shack with a trailer hidden somewhere beneath it all. A system of walkways crisscrosses the sewage ditch and leads on one end to Slick's photography studio and on the other to the reloading room, where he cleans his guns, sharpens his knives, and spruces up his Civil War reenactment paraphernalia. Massive interlocking vines hold these additions together, anchored by poison ivy plants with leaves as big as the young man's feet. Squeezing by, careful not to brush against anything, the men walk on ahead, beyond the carport, to the edge of the swamp, where heaps of carcasses bake in the sun.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA34"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.35.1.0.box.178.244.1377.1996.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.0.box.178.244.1374.869.q.60"
    }
  }, [_vm._v("The son-in-law regards it all less out of curiosity than with the wary eye he has developed in his ten years as a patrol officer, walking his beat through some mighty frigid winters, worlds away from a day like today. Hollowed-out crab shells, bleached crawfish heads, translucent shrimp hulls — shellfish mausoleums with little to offer the flies frequenting the gravesites. If it can be eaten, the odds are good that Slick has eaten it first. As a bonus, the smell attracts critters, possums and coons especially, which Slick shoots with his .22 from the swivel rocker in his living room. Straight through the screen door. The irrefutable evidence of Slick's unorthodox technique — sixteen holes in the screen, each the size of a pockmark, the blast pattern consistent with a shot fired from the inside. \"That boy's the laziest bastard I ever known,\" the old man remarks, \"but he's a damn good shot for a blind fella.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.1.box.229.1130.1032.45.q.70"
    }
  }, [_vm._v("Just then, the host emerges from the dark recesses.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.2.box.179.1190.1373.423.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.2.0"
    }
  }), _vm._v("\"Hey, what ya know, B.\" Slick's movements are quick but they're jerky and oddly off balance, a lot of energy going nowhere fast. His speech is much the same, thickly Cajun with frequent sputters and tics that step on everyone else's toes. Clean-shaven and freshly groomed, his personal hygiene stands in stark contrast to his housekeeping skills. Glasses thick as a two-by-four rest unevenly on his nose, held together at every joint by wads of duct tape.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.3.box.182.1627.1373.613.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.3.0"
    }
  }), _vm._v("At the old man's urging, Slick demonstrates his screen-door pointand-shoot technique, complete with firearm retrieved from beneath the La-Z-Boy; then he offers a five-cent tour of the place. The son-inlaw moves slowly and cautiously through the maze, ducking beneath light fixtures and doorjambs. They pause only briefly in the Hall of Co-Eds, where framed glossy yearbook photos of lovely undergrads hang askew. Most were taken, Slick explains, during his stint as the official graduation photographer at several local schools. \"Don't worry,\" the old man points out, a glint in his eye, \"they're all accounted for.\" Which, as far as anyone knows, is true.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.35.2.0.box.1147.2318.409.46.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.35.2.0.box.1147.2318.409.46.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Elizabeth ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("H. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Boquet ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA35"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.36.1.0.box.177.264.1373.2177.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.36.1.0.box.180.264.358.90.q.80"
    }
  }, [_vm._v("10:00 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.36.1.1.box.178.444.1371.552.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.2.0.0"
    }
  }), _vm._v("As I "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Enter the coolness ")]), _vm._v("  of St. Paul's Episcopal Church in Abbeville, pulling open the thick, solemn, engraved doors and passing into the sanctuary, a rainbow lights the darkness from window after window of stained glass. Pictures of saints: Augustin, Theodore, Louis, Peter, Joan of Arc, Jesus, and then you — I stop, drawn to your little face. Your curly golden hair surrounds a sweet ethereal countenance, pink-cheeked, a partial smile on your lips as if you know a secret but can't tell. Little Henry Edwards, immortalized and forever young. What is your story?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.2.box.177.1013.1373.870.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.2.1.0"
    }
  }), _vm._v("\"Son of Dr. and Mrs. Clarence Edwards,\" I read below your picture, yet he couldn't save you, Henry; I wonder why. Did it haunt him the rest of his life? There is an angel standing over you, holding your hand —your little fingers grasp back tightly, trustingly. She shields you with wings of pale white, covering you like a silk blanket. Why do you smile? Are you thinking of your mother? Is she still here, somewhere in this town, coming to light a candle each day for you and praying still for God to heal the empty space in her heart where faith no longer lives since you left her? At night when she lies awake, does she still feel your soft skin and smell your hair and hear your voice saying, \"Momma?\" She must come here to sit and look at you on days when she can no longer bear the stillness of her house, of her thoughts, of being alone. You hold a cross against your heart. Are you still smiling, Henry?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.1.3.box.178.1898.1372.543.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.2.2.0"
    }
  }), _vm._v("I have a son, Henry. He is only a year old and like you he has hair like ripe corn silk and serious eyes of brown that hold mysteries, too, and sometimes I sneak into his room at night and lay my hand on his back, checking to make sure he's breathing. (I have done this since my husband made me put him in that baby bed so far away from me.) I wake up some nights, heart pounding, and listen to the dog snoring beside my bed and the soft, steady breath of my husband and then it comes — the sweat and my heart against my chest and I wonder about him and hesitantly get up. The walk to his bedroom is"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.37.1.0.box.178.256.1370.302.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.0.0"
    }
  }), _vm._v("\nlong and fearful and until I put my hand there on the back of his Tshirt and feel it, the rhythmic up and down staccato beat of his heart, there is a tingle in my chest that almost chokes me. I think you must be shaking your head and laughing at me now, Henry. But I wonder if your mother ever did the same.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.2.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA36"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.37.1.0.box.178.256.1370.302.q.50"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.37.2.0.box.1265.636.284.43.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.37.2.0.box.1265.636.284.43.q.80"
    }
  }, [_vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Jerre ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Borland ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA37"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.38.1.0.box.178.262.1370.2179.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.38.1.0.box.182.262.340.90.q.80"
    }
  }, [_vm._v("10:10 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.38.1.1.box.178.445.1370.286.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("October ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Mornings ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Are ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Best ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Time ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Of ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Day ")]), _vm._v("of the best month in South Louisiana. The day's heat hasn't set in yet, the sky is blue, and breeze sweeps the air. All Saints' Day is coming up next weekend. Families have come to the cemetery to take care of the graves of their dead.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.2.box.178.759.1370.238.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.2.1.0"
    }
  }), _vm._v("An old lady moves with a walker through the middle of the cemetery. She is with her granddaughter and her granddaughter's husband, and they are looking for the graves of her mother and father. She used to know exactly where they are. . . .")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.3.box.178.1012.1370.551.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.2.2.0"
    }
  }), _vm._v("They had come down this morning from Baton Rouge on La. 1. They passed sugarcane fields and chemical plants. Many of the houses they passed had blue Virgins in the yard. And they had come through the place of her birth. Although the house no longer stands there at Grand Bayou, she recognized the place by the old mossy oak tree, which remains as a grave marker of sorts. The marker had directed them to the Paincourtville cemetery, and now she had to find ... aaah, here they are ... the graves of Adia Landry and Joseph Albarado.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.4.box.178.1581.1370.173.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.2.3.0"
    }
  }), _vm._v("Her granddaughter opens the lawn chair for her, and she sits in the shade and watches as the younger woman and her husband begin scrubbing the elevated graves in preparation for whitewashing.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.5.box.178.1770.1370.671.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.2.4.0"
    }
  }), _vm._v("Several others at the same task stop by during the morning. A few recognize the old lady; others introduce themselves and ask whom she is related to and how. Her granddaughter listens to all the stories about the families and about the old days —about the men tracking and killing the alligator that had bitten Parrain Petit's leg in 1935 until he gouged out the alligator's eye with the spur on his boots used to climb trees to collect moss for mattresses; of the time every spring when the waters came and the families would put their furniture as high as they could and leave in a flatboat to \"where the water ended\"; about how as a girl Nolda and her girlfriend Icy would fix a big bowl of sweet potatoes, raw with salt,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.39.1.0.box.178.254.1370.111.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.1.0.0"
    }
  }), _vm._v("\npepper, and vinegar, and climb up to the roof to eat them. Laughs and memories connect the pieces, and there is a connected peace.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA38"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.39.1.0.box.178.254.1372.540.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.1.1.box.178.382.1372.412.q.60"
    }
  }, [_vm._v("The sun rises higher, the graves are painted, and they decide that the job is good enough for another year. They return to the car, and the lady directs them to a service station/restaurant where she insists on buying fried shrimp po' boys. She puts her hand on top of her granddaughter's. She is not sure that she will be here next year, but her anxiety is gone: she knows in her bones that the graves will be tended.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.39.2.0.box.1028.886.521.47.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.39.2.0.box.1028.886.521.47.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mike ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Stacy ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("O'Rourke ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA39"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.40.1.0.box.177.262.1376.2179.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.40.1.0.box.182.262.358.90.q.80"
    }
  }, [_vm._v("10:30 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.40.1.1.box.178.445.1373.552.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.2.0.0"
    }
  }), _vm._v("A "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Flock ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Of ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Canvasback ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Ducks, ")]), _vm._v("pale gray and white with ruby-red eyes, cuts through the crisp October air in a "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("V ")]), _vm._v("shape, outpacing the SUVs and pickup trucks crawling across the Mississippi River Bridge into Vidalia. Beneath them, the flat and steady track of Highway 84 is littered on either side with endless strip malls. On the outskirts of nearby Ferriday stands a lone place of worship, a brown, barnlike building. The Church of God marquee on wheels sits at the edge of the road, its blue plastic letters proclaiming, \"Walmart is not the only saving place.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.2.box.179.1013.1372.552.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.2.1.0"
    }
  }), _vm._v("At Ferriday, the highway turns west. Within a few miles, a vast cotton field appears, stretching like a giant Monopoly board to the far horizon. An oblong office building occupies Park Place; in the distance, past Luxury Tax and Short Line Railroad, sits a row of tiny cabins with red tin roofs. All 1,800 acres are rich in the soil of easy growth, nourished by repeated flooding of river bottoms. Some fifty yards behind the office looms the computerized public gin, the cream tin structure labeled \"Tanner & Co.\" in red, four-foot-high letters. It produces 800 to 1,000 bales a day.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.3.box.179.1582.1372.236.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.2.2.0"
    }
  }), _vm._v("Lynette Tanner sits behind her desk in the office and runs her hands through her shoulder-length auburn hair, taking a last look at ag updates, scanning the computer screen for worldwide cotton prices. She logs off and phones the gin.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.4.box.177.1834.1375.484.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.2.3.0"
    }
  }), _vm._v("Dorothy Smith, fifty-five, the same age as Lynette, releases the joystick that operates the suction pipe. She cuts the power, silencing the hum of the heavy-gauge metal cylinder. Dorothy exits the glass booth, runs down the stairs, and walks past the trailer she has just whisked clean of cotton. \"Who we got this time?\" she asks, slipping into the passenger seat. \"Some students from LSU,\" Lynette says, grinning, as she wheels her Volvo away from the gin. \"We've got exactly ten minutes to change.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.5.box.180.2333.1373.108.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.2.4.0"
    }
  }), _vm._v("Turning left onto Highway 84, the car sails past the blanket of snow. At this moment, the sun dries the last drop of dew from the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.41.1.0.box.180.251.1371.488.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA40.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.0.0"
    }
  }), _vm._v("\nleaves of the plants, and, on cue, the red harvest machines begin to rumble through the field. Nearby stand the yellow, high-walled module builders that pack the picked cotton into large blocks for ginning. The men raking spilled cotton off the ground or tagging various farmers' cotton have temporarily escaped from the Concordia Parish Correctional Facility. In the work release program, they get minimum wage, workman's compensation, and days of freedom.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA40"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.41.1.0.box.177.251.1374.1430.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.1.box.179.756.1372.362.q.60"
    }
  }, [_vm._v("Nearly two hundred years into the past, Lynette, mistress of Frogmore Plantation, emerges from the two-story, columned big house wearing a long, black cotton dress trimmed in white eyelet with pantalettes and full petticoat, her hair upswept in a pearl clasp. She walks the short distance to the mid-1800s plantation church and greets her tour group.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.2.box.177.1135.1374.546.q.60"
    }
  }, [_vm._v("In a nearby slave cabin, Dorothy, whose ancestors were slaves at Frogmore, entertains her tourists with cooking methods circa 1850. Dressed in an ankle-length, gray cotton muslin shift and white apron, Dorothy places a \"hoecake\" — a cornmeal pancake —on the blade of a hoe and warms it over the fire. Suddenly, a recording begins to play, filling the cypress-timbered shack with song: "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("gospel ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("train's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a-comin'. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Get ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("on ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("board, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("little ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("chillun. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("gospel ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("train's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("comin'. ")]), _vm._v("\"Of course,\" Dorothy begins, \"the train they are referring to was the Underground Railroad. . . .\"")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.41.2.0.box.1227.1760.324.48.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.41.2.0.box.1227.1760.324.48.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Chance ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Harvey ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA41.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA41.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA41"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.42.1.0.box.177.262.1372.2179.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.42.1.0.box.180.262.358.90.q.70"
    }
  }, [_vm._v("10:35 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.42.1.1.box.177.443.1371.490.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.2.0.0"
    }
  }), _vm._v("Tricia's ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Mother, ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Catherine, ")]), _vm._v("shouted, \"Roll up the windows and get down on the floorboard. Lock the doors and get down, now! Hurry!\" It was a hot and sunny day in May of 1968. Too hot, even at 10:30 in the morning, to have all the windows rolled up in the car, for sure. Tricia could feel the sweat beading up on her face and in her hair. There was sandy grit underneath her hands and knees from the dirty black rubber floor mats of her parents' Ford Fairlane station wagon.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.1.2.box.178.949.1371.425.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.2.1.0"
    }
  }), _vm._v("One of the three Klansmen was tapping on the passenger window with his knuckle and making a rolling gesture with his forefinger and hand in a vain attempt to get Catherine to roll the window down so he could give her a piece of paper with big black lettering—the page overflowing with Klan propaganda. Tricia couldn't make out much of what they were saying, but she understood the hate in their tone and the word \"nigger.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.1.3.box.178.1390.1370.425.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.2.2.0"
    }
  }), _vm._v("Maybe those men thought Tricia's father was a \"nigger\" too. After all, Len Doughty had thought so. His first words to her at school had not been \"hello\" or \"may I carry your books?\" Instead, he'd said, \"Your father is as black as a nigger.\" The statement was very matter of fact, like it was the gospel, and he'd said it right in front of the whole class. Then, Len smiled at her as the class snickered. Tricia missed the joke, somehow.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.1.4.box.178.1831.1370.235.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.2.3.0"
    }
  }), _vm._v("\"My father is part Choctaw Indian and just got back from Saudi Arabia, I'll have you know!\" was her curt retort. She was "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _vm._v("going to let Len or any of her classmates make her ashamed of her father's golden skin.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.1.5.box.178.2082.1371.297.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.2.4.0"
    }
  }), _vm._v("Tricia hated living in Dubach. Hate. There was not as much of it here as there was in the large cities or as much of it as she watched on television at night but hate did exist here. Now, hate was standing right outside their car dressed in white flowing robes and pointy hoods.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.1.6.box.227.2395.1322.46.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.2.5.0"
    }
  }), _vm._v("Tricia's mother forgot the car was already running so the motor"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.43.1.0.box.178.254.1370.235.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA42.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.0.0"
    }
  }), _vm._v("\nmade a grinding noise when she turned the key. \"S—,\" she said. \"Kids, no matter what, don't open the doors.\" Their mother backed the car onto Main Street, leaving the Klansmen still standing in the parking space. All Tricia"), _c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.1.0"
    }
  }), _vm._v(" could see was their eyes.")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA42"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.43.1.0.box.178.254.1370.553.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.1.1.box.179.505.1369.175.q.60"
    }
  }, [_vm._v("\"One of them sounded just like Billy Joe Clary,\" Catherine would say to Tricia's father that night after they thought the kids were asleep. \"I know that was him because I recognized his voice.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.1.2.box.179.695.1369.112.q.60"
    }
  }, [_vm._v("\"Hmmm,\" Tricia thought silently to herself. Hate, it seems, owns the gas station and the town's diner, too.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.43.2.0.box.1250.885.301.35.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.43.2.0.box.1250.885.301.35.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Patricia ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Baker ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA43.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA43.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA43"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.44.1.0.box.177.264.1373.2167.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.44.1.0.box.182.264.360.88.q.60"
    }
  }, [_vm._v("10:43 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.44.1.1.box.177.444.1373.427.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.2.0.0"
    }
  }), _vm._v("Harry ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Answers ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Bullhorn ")]), _vm._v("of the Red Cross food truck the way a boy answers the spit of a nun's whistle calling him in from recess. He appears at his door and with a squint surveys North Villere Street as if to assure himself he has heard correctly. Gingerly he picks his way down the cement steps of the turquoise shotgun house. The steps are piled high with black plastic bags brimming with his worldly goods. They are arranged there, barricade style.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.1.2.box.178.886.1371.298.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.2.1.0"
    }
  }), _vm._v("His Shadow doesn't bother with the wrought-iron handrail. He leaps nimbly over the same bags. Once landed, he too looks up and then down the same street as if choosing between two colorful posies to carry to his girl, then smoothes the lapels of his orange brocade jacket.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.1.3.box.178.1202.1371.301.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.2.2.0"
    }
  }), _vm._v("The scents of stale urine and greasy food are trapped among the layers of sweaters and shirts Harry wears to ward off the unseasonable January cold. His thinning gray hair, the part not covered by his cap, sports curled balls of old lint. His lone remaining tooth, yellowed, peeks out only when he smiles.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.1.4.box.178.1519.1372.547.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.2.3.0"
    }
  }), _vm._v("His Shadow sets off east toward the streetcar that will fetch him uptown, to where the dancing is. A smile breaks across his face echoing the tune his shoe heels strike out as they clatter against the pavement. He hums to the rhythm of his walk. He salutes his auntie, Momma Rose, who fans herself, perched on her front porch in a faded blue rocker. He treats her to a wolf whistle. She shouts back, \"Ya gwon, na, Harry. Y'all couldn'a handle what I got ta give, baby.\" Her laugh trails him down the street arched over with fragrant oak boughs.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.1.5.box.178.2083.1371.297.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.2.4.0"
    }
  }), _vm._v("Harry steps gingerly over a piece of yellow siding ripped from a house around the corner. The storm blew it there and city workers have not hauled it away. He sidesteps it from habit, though once its brightness stuck out against all the gray debris. He turns his gaze to the crooked sidewalk, minding his step lest he break another bone.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.1.6.box.228.2396.1321.35.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.2.5.0"
    }
  }), _vm._v("His Shadow is headed to the arms of his crescent mistress. She is"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.45.1.0.box.177.245.1370.224.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA44.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.0.0"
    }
  }), _vm._v("\na mahogany woman who enflames him simply by wrapping him in the warmth of her jasmine-scented arms. Just as often, though, she flings his affections windward and cackles at his feeble attempts to desert her.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA44"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.45.1.0.box.176.245.1372.931.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.1.1.box.177.496.1371.302.q.60"
    }
  }, [_vm._v("And now, Harry's old mistress is on her knees vomiting waste of all sorts onto the streets. Harry stands by, close. The arthritis that has bent him nearly in two prevents him from hauling his mistress to her feet by himself. Instead, he whispers words of soft encouragement that only she can hear.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.1.2.box.177.815.1369.108.q.50"
    }
  }, [_vm._v("\"Come on, my darlin'. Stand, na. We gots to get you cleaned up so we's can go dancin'. It's near Carnival time.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.1.3.box.176.940.1371.236.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.3.0"
    }
  }), _vm._v("Harry turns slowly away from the truck, his food bags slung over his arm, and picks his way back again toward the cluttered front steps. He chuckles quietly as he goes. His Shadow follows, a silent smile on his face, in slow step with Harry.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.45.2.0.box.1128.1256.419.47.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.45.2.0.box.1128.1256.419.47.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Marianne ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mansfield ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA45"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.46.1.0.box.177.262.1373.1429.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.46.1.0.box.182.262.356.88.q.60"
    }
  }, [_vm._v("10:55 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.46.1.1.box.178.442.1372.300.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.2.0.0"
    }
  }), _vm._v("After ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("A ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Spring ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Flood ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("In ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Orleans, ")]), _vm._v("it is quiet and the air is still, charged with the mineral essence of damp earth, decaying wood, and lingering ozone. After the hard rains, the banana trees shine like exotic green fan blades, their ridges still incandescent with moonglow.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.1.2.box.177.758.1373.489.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.2.1.0"
    }
  }), _vm._v("It is Sunday morning, the day after the flood, and the French Quarter is empty. No merchants, no tourists, no Lucky Dog man, no breakdancers, no cars. The water has subsided, but the fear and dread have not. There is no one yelling, no Dixieland streaming out of dark bars, no cloppity-clop of horses pulling carriages. Jackson Square seems totally abandoned, then, straight through the turbid atmosphere comes a woman's voice. It is a strong, steady voice, singing \"Bye Bye Blues.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.1.3.box.178.1263.1371.351.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.2.2.0"
    }
  }), _vm._v("The brown-haired woman, who can't be more than twenty-five, if she is that, wears a long skirt and holds a megaphone. She continues singing through it: \"Sun is shining, no more pining. . . .\" The melody is heartbreaking; she knows this. Slowly, people appear, mopping up sidewalks, removing wet rugs, and quietly exchanging stories.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.1.4.box.228.1642.1207.49.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.2.3.0"
    }
  }), _vm._v("\"Don't sigh, don't cry,\" she sings to them. \"Bye bye blues.\"")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.46.2.0.box.1158.1771.390.46.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.46.2.0.box.1158.1771.390.46.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.3.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Diane ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Elayne ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Dees ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA46"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.47.1.0.box.178.254.1373.2175.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.47.1.0.box.180.254.340.88.q.60"
    }
  }, [_vm._v("11:05 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.47.1.1.box.178.435.655.34.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("\"Betcha ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Never ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Heard ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.0.0"
    }
  }), _vm._v("A' ")]), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.1.0"
    }
  }), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Lydia.\" ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.2.box.228.497.664.47.q.60"
    }
  }, [_vm._v("\"Can't say I have, 'cause I ain't.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.3.box.178.561.1368.110.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.2.0"
    }
  }), _vm._v("\"That's 'cause it ain't even a wide spot in the road. The road jes' barrels on through without even a speed limit sign.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.4.box.238.687.489.36.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.3.0"
    }
  }), _vm._v("'So —where'n hell is it?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.5.box.178.750.1368.111.q.60"
    }
  }, [_vm._v("'On Weeks Island Road, south of State "), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.4.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.5.0"
    }
  }), _vm._v("90. And don't go tellin' me you never heard a' Weeks Island, neither.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.6.box.229.877.663.47.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.6.0"
    }
  }), _vm._v("\"Can't say I have, 'cause I ain't.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.7.box.179.940.1370.96.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.7.0"
    }
  }), _vm._v("\"Ain't you never been outta the city limits a' Monroe, boy? You don't know nothin'.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.8.box.229.1066.1121.47.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.8.0"
    }
  }), _vm._v("\"Whyn't you quit your braggin' and tell about Linda?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.9.box.229.1129.306.47.q.60"
    }
  }, [_vm._v("\"Lydia, I said.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.10.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.10.box.229.1192.251.34.q.101"
    }
  }, [_vm._v("\"Whatever.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.11.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.11.box.178.1255.1372.295.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.9.0"
    }
  }), _vm._v("\"No speed limit signs, no cops, no fire station, no school, not even a Baptist church, can you 'magine that? "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("In ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Lou'siana? ")]), _vm._v("Nothin' but sugarcane fields as far as you can see, which ain't far 'cause the cane's about twelve foot high. All green an' waving in the afternoon breeze, can't see more than a foot through it 'cause it's so thick.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.12.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.12.box.229.1566.720.40.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.10.0"
    }
  }), _vm._v("\"That's it? A road, an' cane fields?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.13.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.13.box.179.1628.1371.359.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.11.0"
    }
  }), _vm._v("\"Didn' say it was, did I? I ain't got to the good part yet. Now listen heah. They's a few houses with them tin roofs, kids' toys an' crappy cars out front, an' a fillin' station with a store inside. They sells some right good cracklin's in a bag, local made stuff an' good an' fresh. Bag a' cracklin's an' a couple a' cold Dixies, that's the way to spend a summer afternoon.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.14.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.14.box.180.2005.1371.111.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.12.0"
    }
  }), _vm._v("\"That's the good part? Fried pork hide an' beer? I can get that right here at this bar. Alls I gotta do is call Mikey over.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.15.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.15.box.180.2131.1370.298.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.2.13.0"
    }
  }), _vm._v("\"No, that ain't the good part, genius. Here's the good part. The gal behind the counter workin' the cash register, she a mulatto, ya know? What we useta call a briquette in N'Awlins. But she is drop dead beautiful. Mos' beautiful gal I ever seen. Beautiful black hair, straight and down on her shoulders. Beautiful eyes, kinda green,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA47.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.48.1.0.box.178.253.1371.299.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA47.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA47.w.1.0.0"
    }
  }), _vm._v("\nlittle nose, lips like all them movie stars got now, a figure your brain wasn't even made to imagine, and wearing tight pink shorts an' an Army T-shirt. Lord, she was beautiful. I mean, beautiful! Bare feet, too. Beautiful bare feet with teeny little toes an' the nails painted pink like her shorts.\"")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA47"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.48.1.0.box.178.253.1371.872.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA47.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.1.1.box.228.570.774.40.q.60"
    }
  }, [_vm._v("\"So, she'd have been beautiful, then?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA47.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.1.2.box.178.634.1371.427.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47.w.1.2.0"
    }
  }), _vm._v("'\"Tweren't jes' that. I seen all kindsa gorgeous females, but this'n were different. This'n actually "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("looked ")]), _vm._v("at me. Ain't no woman looked at me in th'eyes since the fire. She done looked at me like I was a real human bean, not some freak. She smiled real nice, ast me how wuz I feelin', ain't it hot out, what nice big shoulders I got. Made me feel like a "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("man ")]), _vm._v("fer the first time since Claudelle th'owed me out. I hadda say g'bye right quick 'fore she seed the tears in m'eyes.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA47.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.1.3.box.229.1077.939.48.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47.w.1.3.0"
    }
  }), _vm._v("\"Damn. This calls for two more. Hey, Mikey!\"")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.48.2.0.box.1230.1203.319.35.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA47.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.48.2.0.box.1230.1203.319.35.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Graham ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Clarke ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA48"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.49.1.0.box.177.266.1374.1985.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA48.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.49.1.0.box.180.266.324.88.q.60"
    }
  }, [_vm._v("11:15 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA48.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.49.1.1.box.177.446.1373.488.q.50"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Old ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Photograph ")]), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.3.0.0"
    }
  }), _vm._v("I "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Am ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Holding ")]), _vm._v("shows me, about three years old, and an old black man, Nathan. He is holding my hand and my other hand is holding a toy pistol he has carved for me from a block of cypress. The photo was taken in 1926, about quarter past eleven in the morning. Nathan worked for my father, manager of a Gulf Oil filling station in New Iberia. One of my earliest memories is the day Nathan took me on my first fishing trip —I was about five or six years old.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA48.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.1.2.box.178.950.1372.598.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48.w.3.1.0"
    }
  }), _vm._v("Early that morning I went down to the Gulf station with my father and then walked across Main Street for breakfast at the Frederick Hotel. Then Nathan and I set off walking down Main Street to Brooks' Stable, located next door to LeBlanc & Broussard Ford Company. My father had gotten permission from Mr. Saul Brooks to dig for worms in the stable. I can still smell the rich, pungent odor of the stable where Mr. Brooks kept his inventory of new and used mules for sale. We quickly filled our bait can and made our way around the corner of Weeks Street to the bank of Bayou Teche.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA48.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.1.3.box.179.1576.1371.299.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48.w.3.2.0"
    }
  }), _vm._v("Nathan brought two cane poles and showed me how to load the hook with squirming, slimy worms. I was squeamish about it but, being the big man that I was, I didn't let on and followed his lead. After overcoming that obstacle, it was lines in the water to wait for the big one.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA48.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.1.4.box.179.1890.1372.361.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48.w.3.3.0"
    }
  }), _vm._v("Well, I wish I had a good fish story to tell, but it was not to be. After about an hour or so we had hooked one small perch, which we threw back. We decided to give the rest of the worms to the fish and go home. I learned a lot about fishing that day, like they don't always bite—but it was a great adventure for me. I think Nathan had a good time, too.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.49.2.0.box.1306.2330.245.47.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA48.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.49.2.0.box.1306.2330.245.47.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48.w.4.0.0"
    }
  }), _vm._v("-R. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("C. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Sealy ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA49"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.50.1.0.box.177.262.1373.2172.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA49.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.50.1.0.box.180.262.346.86.q.70"
    }
  }, [_vm._v("11:24 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA49.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.50.1.1.box.177.439.1373.1995.q.60"
    }
  }, [_vm._v("So "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("We Go Out To ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Cafe ")]), _c('a', {
    attrs: {
      "id": "GBS.PA49"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.3.0.0"
    }
  }), _vm._v("on a windy, steamy day that's more like pensacola beach than new orleans, and there is anne, reading a book called "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mind ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("god, ")]), _vm._v("and robin who recognizes somebody passing on the street just from her back, and i say, \"what's new?\" and anne says, \"there is a nine-year-old girl who just raised money to buy bullet-proof vests for k-9 police dogs,\" and laura says that she actually saw the news where some crazy felon ran from the police and hid under a house and shot a police dog, which was terrible and that's probably what the nine-year-old girl thought, and i just had my eighth cup of coffee and i have no idea what my column this week is going to be all about, so i say, \"i'm going to raise money to buy protective gea"), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.3.1.0"
    }
  }), _vm._v("r for cockroaches\" (which in louisiana are big and sentient like little crunchy dogs), and anne says, \"little boxes,\" and i say, \"yeah, little boxes where only their heads and legs stick out and there is a little warning light and a taped voice that says just as you're about to step on them: 'agrrhr rrr kstn,'\" and laura points out that the calliope on the river is playing \"that's amore,\" and we discuss post-modern literature for some reason, with robin pointing out that "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mind ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("god, ")]), _vm._v("presently lying next to my coffee cup, has an introduction to an introduction, and i describe (in a few dozen words) nabokov's "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pale ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("fire, ")]), _vm._v("which as everyone knows is a crime novel disguised as an academic gloss on a long and bad poem, and anne says, \"don't forget compassion,\" apropos of the kind child who cares about k-9 safety, and i say, \"no, of course not,\" because if columnwriting is about anything it's about high moral standards and lessons about life, even the life of cockroaches (i am a jain) and then we discuss the art show by sex workers which has just opened in new orleans, and i think that it's the same show i saw in portland last year, which showed the work of about three hundred sex workers, and then we say goodbye for now to anne and robin, and oh, i forgot, she said that there was a real-estate convention in town and five realtors told her that i was great, and last week there were dentists"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA50.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.51.1.0.box.177.241.1372.423.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.1.0.0"
    }
  }), _vm._v("\nall over and everybody was smiling, now that's the human world, happily we don't need bullet-proof vests here, and i feel compassion, yes i do, and i forgot about this poem laura and i made up walking down the street to the cafe that goes partly, \"too young to shave/in a world of clueless tourists,\" which i wrote down with some more lines in anne's notebook for her to make a little book out of, and i'm sure there are a lot of other things i forgot or that i can't tell.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50.w.2.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA51.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA50"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.51.1.0.box.177.241.1372.423.q.60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.51.2.0.box.1198.742.349.36.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA50.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.51.2.0.box.1198.742.349.36.q.70"
    }
  }, [_vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Andrei ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Codrescu ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA51"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.52.1.0.box.177.264.1373.1732.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA51.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.52.1.0.box.180.264.338.88.q.70"
    }
  }, [_vm._v("11:57 A.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA51.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.52.1.1.box.177.444.1373.1552.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51.w.2.0.0"
    }
  }), _vm._v("It ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Is ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("A ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Jealous ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Summer ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Heat. ")]), _vm._v("The hot air has arms and legs. The temperature snatches at one's entire being. It forces the young girl to give up on her windblown hair. Her skirt teases sticky legs from the sun's drenching wet fingers. She drowsily walks along the bright day. It is quiet. There are no birds singing. The sun has chased them from the sky to wait out the evil high noon. The grass is dead from lack of rain. The soil is dry like an old woman's skin. She continues to slowly drag along and stops in front of a small shacklike house. It hardly seems to coincide with the loving description of a home. The fact that it is even fit, or was ever fit, to shelter humans puzzles the girl. The outside walls are constructed from some type of mud mixture. The unforgiving sun has bleached them beyond white, almost transparent. She runs her finger down the front wall. Her fingers trail after every bump and nick. She looks up. The roof is poorly built out of some type of wooden stilts and straw. She steps across a wooden beam, guessing it to be the door frame, and goes inside. The quiet outside is nothing compared to the inside of the shack. The girl shuts her eyes momentarily. Perhaps she is thinking of past lives sitting at the hearth. The fireplace is nothing more than a gaping whole and crumbly crimson bricks. The floor is parched dirt. She kicks a few rocks and pebbles as she walks around. She is told slaves lived here. She is told slaves ate here. She is told slaves gave birth here. The heat is still greedy. Her skirt continues to stick to her damp ankles. Even so, the girl shivers and walks back out into the sun.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.52.2.0.box.1070.2083.480.34.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA51.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.52.2.0.box.1070.2083.480.34.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51.w.3.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Sarah ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Elisabeth ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Roussel ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA52.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA52.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA52"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.53.1.0.box.177.252.1373.2174.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.53.1.0.box.180.252.364.88.q.60"
    }
  }, [_vm._v("HIGHN00N")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.53.1.1.box.178.432.380.35.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Down. ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Set. ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Geaux. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.53.1.2.box.178.494.1370.111.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.2.1.0"
    }
  }), _vm._v("Gators in town, rightly waving their index fingers, wanting to know what we've got.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.53.1.3.box.227.621.290.41.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.2.2.0"
    }
  }), _vm._v("So, I tell them.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.53.1.4.box.177.684.1370.173.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.2.3.0"
    }
  }), _vm._v("I've got five pints of Jim Beam strapped to my back and thighs. I've been up since Thursday. Today is Saturday. Today is game day. This is Death Valley.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.53.1.5.box.178.874.1370.96.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.2.4.0"
    }
  }), _vm._v("Ninety-six degrees in the oaken shade. This ain't Mardi Gras, no, but it feels like it.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.53.1.6.box.177.1000.1372.300.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.2.5.0"
    }
  }), _vm._v("I know everybody here. The andouille man, the half-assers, the gumbo folks that sit beneath the tree-fan, but they don't know me. Still, today I wear the right colors so they lob me icy beers like tenyard slants. Tomorrow we may all crawl back into the concrete, sure, but "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("today, ")]), _vm._v("they say, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("what's ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ours ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _vm._v("all "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ours. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.53.1.7.box.178.1316.1372.419.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.2.6.0"
    }
  }), _vm._v("So, I catch them. Crack them open. I pass one over to Dough, my buddy with the titanic heart. He's a Baton Rouge guy who works like a serf at Brew-Bacher's Restaurant, smuggling hot wings and po' boys back to our place whenever possible, feeding his wages into video poker. He requested this day off seven months ago. We all did. This is game day, by God, this is prime-time against number one, and we are in this together.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.53.1.8.box.229.1752.337.46.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.2.7.0"
    }
  }), _vm._v("Dough's excited.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.1.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.53.1.9.box.228.1814.847.47.q.60"
    }
  }, [_vm._v("He shaved his head last night at 6:00 a.m.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.1.10.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.53.1.10.box.178.1877.1372.230.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.2.8.0"
    }
  }), _vm._v("He stood atop our living room table as he did this, the stereo bumping, a few blond-headed maybes watching him from our couch with crossed legs. This "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("good ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mojo, ")]), _vm._v("he told them, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("what ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("takes ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("win!, ")]), _vm._v("and his hair fell like a blasted duck's feathers.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.1.11.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.53.1.11.box.228.2130.1094.46.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.2.9.0"
    }
  }), _vm._v("Then, all together, us and the girls, we saw the dawn.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.1.12.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.53.1.12.box.178.2192.1372.98.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.2.10.0"
    }
  }), _vm._v("But now my friend is crashing. It's understandable. It's high noon under hot sun.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.1.13.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.53.1.13.box.178.2317.1371.109.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.2.11.0"
    }
  }), _vm._v("Still, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("This ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("type ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("love ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("is ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("marathon! ")]), _vm._v("I tell him, and slap my buddy hard on the head. He agrees, opens his eyes with his fingers, and I"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA53.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.54.1.0.box.179.252.1378.161.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA53.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA53.w.1.0.0"
    }
  }), _vm._v("\nrub the stubble on his skull for good luck. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Look ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("at ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("all ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bait, ")]), _vm._v("I tell him. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Wouldn't ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("you ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("love ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("send ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("them ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("packing? ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Wouldn't ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("sing ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pull ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("off ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("miracle? ")])])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA53"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.54.1.0.box.177.252.1380.1438.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA53.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.54.1.1.box.228.442.817.49.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I'm ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("on ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it, ")]), _vm._v("Dough says, and I believe him.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA53.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.54.1.2.box.230.507.592.47.q.60"
    }
  }, [_vm._v("Because Baton Rouge is ours.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA53.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.54.1.3.box.178.570.1371.301.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53.w.1.2.0"
    }
  }), _vm._v("This is the place of our birth. It is cracked tar and jungle hot all the time. It is unmowed medians and copious billboards, spent chewing gum boiling up on our sidewalks. This is the unshaven neck of the Mississippi River, the bulbous brain of Cancer Alley, and we have bullet holes, like sores, on our capitol building.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA53.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.54.1.4.box.227.885.473.40.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53.w.1.3.0"
    }
  }), _vm._v("So, we take a lot of s—.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA53.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.54.1.5.box.177.949.1372.298.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53.w.1.4.0"
    }
  }), _vm._v("But, we also have "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this. ")]), _vm._v("We have right now and today, these few simple acres of purple and gold, and, therefore, we allow no blasphemous tread. In "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this ")]), _vm._v("minute, we roam the stadium grounds like the Bengals we adore. We pass bottles and palm smokes. We wait for evening to pull in like a train.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA53.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.54.1.6.box.228.1264.353.34.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53.w.1.5.0"
    }
  }), _vm._v("We are not alone.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA53.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.54.1.7.box.177.1326.1370.111.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53.w.1.6.0"
    }
  }), _vm._v("It's only noon now, sure, it's still early, but it "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("will ")]), _vm._v("become night in Death Valley.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA53.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.54.1.8.box.228.1454.727.35.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53.w.1.7.0"
    }
  }), _vm._v("It "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("will ")]), _vm._v("become the heart of our state.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA53.w.1.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.54.1.9.box.227.1516.984.49.q.60"
    }
  }, [_vm._v("So, forgive us our frenzy. Forgive us our shouts.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA53.w.1.10.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.54.1.10.box.228.1580.615.47.q.70"
    }
  }, [_vm._v("It's hot here. We may not win.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA53.w.1.11.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.54.1.11.box.228.1644.927.46.q.70"
    }
  }, [_vm._v("But we keep cool by the breath of our chorus.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.54.2.0.box.1267.1771.279.34.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA53.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.54.2.0.box.1267.1771.279.34.q.40"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53.w.2.0.0"
    }
  }), _vm._v("-M.O.Walsh ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA54"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA54.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA54.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA54.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA54.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA54"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.55.1.0.box.177.258.1374.2160.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA54.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.55.1.0.box.180.258.356.86.q.50"
    }
  }, [_vm._v("12:04P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA54.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.55.1.1.box.177.437.1372.477.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Screen ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Door ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Is ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Painted ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Green ")]), _vm._v("and squeaks. Crawfish on newsprint, boiled red with pop-eyes burning black from cayenne, and cold Jax beer in brown bottles, with Satchmo rupturing an old brown radio in the back room. Hear the bottle tops' metallic burp seconds before fizz collides with Tabasco on an old man's tongue. No neighborhood gossip, only the game in black and white from a beery corner, the bat's crack outdone by shells splitting, piled high as Grandma's worries.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA54.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.55.1.2.box.179.942.1371.609.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA54.w.2.1.0"
    }
  }), _vm._v("No interest in slot machines — that handful of change could buy another beer —but baseball, where plates are marked clearly, measured inch by yard, and success comes almost by instinct, an eye on the ball and a glove in the air. Vicariously he spits tobacco juice from the bulge in his cheek, pulls his cap down, and waits for fate to look him in the eye. Now time for the last swallow of lager and out again into the cancer-god sun to read gas meters, drive home in the black bubble-hooded Pontiac to make another child or two, and wake up to biscuits, molasses, and grits, with just enough time on Earth to teach his grandchildren their bedtime prayers.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA54.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.55.1.3.box.179.1568.1371.348.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA54.w.2.2.0"
    }
  }), _vm._v("In the tropical wetness of a New Orleans summer, where the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Natchez ")]), _vm._v("blows its horn over the crescent river, and the neighborhood edging the Quarter has buried the old-timers in St. Louis Cemetery, we drive away, high noon, eyed by hostile natives sitting on stoops, high on crack. I want to call out to them as they diminish in the mirror:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA54.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.55.1.4.box.179.1944.1372.424.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA54.w.2.3.0"
    }
  }), _vm._v("My grandfather was born here and hung his hopes on a barstool long before you sat your despair on that curb and shot up one more time behind the old shed on Frenchmen. My grandpa leaned on that bar, left a dollar for the barman, and walked out pocketing pennies, turning the corner where bougainvilleas pour pink suds over a wooden fence and trolleys clang down a street saturated with mildew and magnolias.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA54.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.55.1.5.box.1212.2385.339.33.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA54.w.2.4.0"
    }
  }), _vm._v("— "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Donna ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Pucciani ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA55"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA55.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA55.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA55"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.56.1.0.box.177.266.1373.2179.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA55.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.56.1.0.box.180.266.334.88.q.70"
    }
  }, [_vm._v("12:17 P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA55.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.56.1.1.box.177.445.1371.239.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA55.w.2.0.0"
    }
  }), _vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Dozen ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Or ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("So ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Patrons ")]), _vm._v("sitting on benches and rocking chairs on The Front Porch in Roseland look toward the door as the bells jingle and it opens. The smell of fried food slowly drifts outside as a young man holds the door open for his very pregnant wife and little boy.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA55.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.56.1.2.box.228.699.1097.47.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA55.w.2.1.0"
    }
  }), _vm._v("\"They must be Catholic,\" an old man says to his wife.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA55.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.56.1.3.box.177.762.1372.553.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA55.w.2.2.0"
    }
  }), _vm._v("A chorus of stomachs rumbles as the famished churchgoers all think about their favorite foods on the buffet spread. Some of the families from the Methodist church scrambled out of their pews as soon as the organ began the closing hymn. Their attempts to beat the rush and be the first to fill their plates up with seafood gumbo, chicken and dumplings, fried fish and chicken, buttery biscuits, cornbread, yellow squash, fried okra, black-eyed peas and rice, and green beans miserably failed. They hope there will still be plenty of dessert left when they finally get a table.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA55.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.56.1.4.box.179.1331.1370.173.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA55.w.2.3.0"
    }
  }), _vm._v("Two elderly women, both wearing brightly colored pantsuits, make their way up the steps of The Front Porch. \"Did you put our name in the pot?\" Ruthie asks her friend who is already waiting.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA55.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.56.1.5.box.179.1521.1370.223.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA55.w.2.4.0"
    }
  }), _vm._v("\"I sure did. It looks like a long wait today,\" Mildred says. \"But I was ahead of most of these people,\" she adds, half-whispering. Mildred picks up her purse, which was saving the spot next to her. She scoots over on the bench and Ruthie and Norma sit down next to her.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA55.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.56.1.6.box.179.1772.1370.289.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA55.w.2.5.0"
    }
  }), _vm._v("\"Thank goodness,\" Norma replies, looking around at the eighteen or twenty people now sitting on benches and rocking chairs and standing up where they can find a place. \"At least the weather is nice,\" she says of the mid-sixty-degree January day. \"It just gets so miserable in the summer, it's almost not worth the wait.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA55.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.56.1.7.box.180.2085.1370.110.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA55.w.2.6.0"
    }
  }), _vm._v("\"I really like Brother Bruce, but his sermons are longer than Brother Travis's,\" Mildred says of the new Methodist pastor.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA55.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.56.1.8.box.180.2210.1369.109.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA55.w.2.7.0"
    }
  }), _vm._v("Several more cars arrive and must park across the street because the small gravel lot in front of the restaurant is full.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA55.w.1.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.56.1.9.box.180.2336.1369.109.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA55.w.2.8.0"
    }
  }), _vm._v("\"Well the Catholics always get here first, but at least we beat the Baptists,\" Ruthie says.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.56.2.0.box.1206.2524.346.46.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA55.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.56.2.0.box.1206.2524.346.46.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA55.w.3.0.0"
    }
  }), _vm._v("-Kathlyn ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Kastner ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA56"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA56.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA56.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA56.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA56.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA56"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.57.1.0.box.177.264.1372.1423.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA56.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.57.1.0.box.180.264.354.90.q.70"
    }
  }, [_vm._v("12:30 P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA56.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.57.1.1.box.178.447.1371.550.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Palo ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Alto ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Plantation ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Is ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Not ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("On ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Tourist ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Maps. ")]), _vm._v("Never was. We circle back on La. 1 along Bayou Lafourche well off the River Road drawn by a back road lined with solid live oaks like aged, arthritic sentinels leading the way past the modest white main house into a world long gone yet lingering as if slave hands had just wandered off on a lunch break, their damp sweat hanging in the stifling noon heat, more cloying in its way than vetiver, the sachets of native swamp-grass roots tied with ribbon and sold in French Quarter boutiques.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA56.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.57.1.2.box.177.1014.1371.421.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA56.w.2.1.0"
    }
  }), _vm._v("Cypress weatherboard cabins of the field hands —one slightly larger denotes an overseer — molder among spider webs, never painted, their grays and browns still vibrant in filtered sunlight. Near a large wooden shed a new John Deere tractor and several skeletal cane trailers to keep it company face out over miles of deep green cane fields waving like swamp grass; they are waiting for grinding season still months away.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA56.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.57.1.3.box.177.1451.1370.236.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA56.w.2.2.0"
    }
  }), _vm._v("Breaking the silence a saddled horse neighs impatiently beside the road, its rider off to who knows where; the sweaty odor is still there, and it occurs to me that the last time we shopped for vetiver sachets in New Orleans, they were imported from Indonesia.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.57.2.0.box.1239.1768.306.45.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA56.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.57.2.0.box.1239.1768.306.45.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA56.w.3.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mary ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Gehman ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA57"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA57.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA57.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA57"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.58.1.0.box.177.264.1373.2176.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA57.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.58.1.0.box.180.264.356.88.q.70"
    }
  }, [_vm._v("12:34 P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA57.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.58.1.1.box.177.444.1372.552.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA57.w.2.0.0"
    }
  }), _vm._v("If ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("There's ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Something ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Tourists ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Find ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Unpleasant ")]), _vm._v("about Jackson Square on a blistering early afternoon in May it's lost on this crowd, bustling and scurrying around horse-drawn carriages, street vendors, panhandlers, gypsies, tramps, and thieves. In the middle of a small throng of denizens shielding their eyes is a man, quite literally statuesque, standing as motionless as his surroundings upon a small box, painted head to toe in sparkling gold. Rays of sunlight reflect off of him in an infinite number of directions, bright and strong as if being shot straight through him.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA57.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.58.1.2.box.177.1012.1373.616.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA57.w.2.1.0"
    }
  }), _vm._v("A loud, guilty click pounds across this quiet meniscus of immobility. As if the city's very air hears it, a wispy thread of cumulus drifts in front of the sun, just partially eclipsing it. If the taming of the sun is to be any refuge for this crowd, they'll never know. Before they can unearth themselves from their ice, an old white man with a yellowish beard in shoes with six-inch-thick soles, dressed in a red, white, and blue striped suit complete with a matching Uncle Sam hat as high as the bottoms of his shoes, cuts across the street pointing at an unsuspecting photographer with camera trained at the golden man.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA57.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.58.1.3.box.177.1643.1372.361.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA57.w.2.2.0"
    }
  }), _vm._v("\"Give that man a dollar!\" Uncle Sam screams as he nears the photographer; life resumes around them and heads turn toward the commotion. In the hand that isn't pointing at the man with the camera, liquor spills out of a brown paper bag, leaving a trail across Decatur that if lit on fire couldn't burn Uncle Sam up more than he already is.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA57.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.58.1.4.box.178.2018.1370.298.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA57.w.2.3.0"
    }
  }), _vm._v("\"You want to take a picture? Go right up to him and give him a dollar. Don't shoot from a block away!\" Sam's finger is pointed right in the photographer's face now, like it is in the posters, in a moment of true surrealism. The finger turns into an empty palm, face up and expectant. \"A dollar.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA57.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.58.1.5.box.178.2333.1372.107.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA57.w.2.4.0"
    }
  }), _vm._v("The photographer reaches into his pocket and pulls out a fold of bills. He peels one off and pays Uncle Sam the tax. Sam walks back"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA58.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.59.1.0.box.177.257.1372.363.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA58"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA58.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA58.w.1.0.0"
    }
  }), _vm._v("\ntoward the golden man; his bottle is empty enough now that it's not dripping along the street. Once there, he lets the dollar fall into the golden man's collection. Uncle Sam turns back to the photographer with a scowl of defensive posture, chucks his paper bag into a nearby trashcan, refusing to tarnish his French Quarter with even the prospect of litter.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA58.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA58.w.2.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA59"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA59.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA59.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA58"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.59.1.0.box.177.257.1372.363.q.60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.59.2.0.box.1211.699.338.36.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA58.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-align": "right"
    },
    attrs: {
      "id": "para.59.2.0.box.1211.699.338.36.q.70"
    }
  }, [_vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Michael ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Gemtne ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA59"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.60.1.0.box.177.262.1373.1111.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA59.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.60.1.0.box.180.262.358.88.q.50"
    }
  }, [_vm._v("12:42P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA59.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.60.1.1.box.177.442.1373.931.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA59.w.2.0.0"
    }
  }), _vm._v("While ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("He ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Waits ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("For ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("A ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Sandwich, ")]), _vm._v("a policeman is talking about meter maids to an older woman in white, with a German accent, working behind the counter of Croissant d'Or in the French Quarter. \"Meter Nazis,\" he says, \"I can't stand 'em either. No, they're not like police officers. They don't carry guns and don't have the power to arrest. They're disgusting. Every one of them weighs about 600 pounds. A few years ago, one is putting a ticket on a police car right in front of the station. An officer comes out, tells her it's a police car, and she keeps writing the ticket. They get into an argument, and she stabs him in the neck with her pen, and he pepper-sprays her. And he gets suspended. Why? Because he was obstructing her from doing her job. What I don't understand is how they're all 300 pounds. All they do is walk around all day long, every day, and sweat, and you'd think they'd lose weight. But they are all 300 pounds. I can't figure that out.\"")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.60.2.0.box.1245.1454.303.35.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA59.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.60.2.0.box.1245.1454.303.35.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA59.w.3.0.0"
    }
  }), _vm._v("-Richard ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Louth ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.61.1.0.box.177.270.1373.1723.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA60.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.61.1.0.box.180.270.302.88.q.50"
    }
  }, [_vm._v("1:06 P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA60.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.61.1.1.box.177.449.1370.298.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Elvire ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Whispers, ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("\"pour ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps",
      "font-style": "italic"
    }
  }, [_vm._v("L'")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps",
      "font-style": "italic"
    }
  }, [_vm._v("Amour ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps",
      "font-style": "italic"
    }
  }, [_vm._v("Du ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps",
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA60"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA60.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA60.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA60.w.2.0.0"
    }
  }), _vm._v("Dieu,\" ")]), _vm._v("for her ears only. She has been itching to get out into the garden all day. Feather beds had needed flattening by a broken broomstick, chickens had needed feeding, and her own solitary lunch of fresh mustard greens and rice had needed cooking.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PA60.w.2.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA60.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA60.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.61.1.2.box.179.764.1368.163.q.60"
    }
  }, [_vm._v("But now as the soft spring afternoon beckons, she takes her faded sunbonnet from its hook near the kitchen door. She tucks slit oval earlobes into its folds and ties a loose bow below her wrinkled chin.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA60.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.61.1.3.box.178.955.1372.421.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA60.w.2.2.0"
    }
  }), _vm._v("Past the dining room table she walks, shoulders hunched. She glances at but does not really see the framed green-and-gray ranks of doughboys behind mustached close-ups of Allied generals of World War I. Padding through the living room, she straightens a ladder-back chair against the beaded board wall where Felicien's piercing blue eyes peer out from a somber face. She calculates again the number of years ago he made her a widow.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA60.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.61.1.4.box.178.1393.1371.360.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA60.w.2.3.0"
    }
  }), _vm._v("An ancient screen door creaks shut behind her as she stands still for a moment on the porch to let her eyes adjust to the sunlight. When her glance falls on the porch-side cistern, Elvire notices for the hundredth time cold rainwater oozing from the faucet onto a green velvet mat of lichen atop a cube of oyster shells naturally cemented together.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA60.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.61.1.5.box.178.1768.1371.225.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA60.w.2.4.0"
    }
  }), _vm._v("She grabs her hoe and breathes in the smell of wisteria vine that has captured the hackberry tree in the corner of the garden, and sniffs gardenias' dizzying sweetness. A whisper of a smile creases her weathered face.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.61.2.0.box.1075.2084.476.46.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA60.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.61.2.0.box.1075.2084.476.46.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA60.w.3.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Claire ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Domangue ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("joller ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA61"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA61.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA61.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA61"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.62.1.0.box.177.260.1372.1929.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA61.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.62.1.0.box.180.260.304.90.q.40"
    }
  }, [_vm._v("1:29P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA61.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.62.1.1.box.177.442.1371.301.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA61.w.2.0.0"
    }
  }), _vm._v("I AM "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Standing ")]), _vm._v("IN A "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Sunny, ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Grassy ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Field ")]), _vm._v("with Wade Theriot, the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("trai")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("teur* ")]), _vm._v("on his farm less than a mile from the tiny village of Bayou Portage, which lies by the western levee of the Atchafalaya Swamp. Wade treats for any and all complaints and reports decades of successful treatments, \"but it's God who does the healings,\" he insists.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA61.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.62.1.2.box.177.759.1372.425.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA61.w.2.1.0"
    }
  }), _vm._v("T'Rouge, the glossy orange and black rooster I've just brought Wade, is adjusting to his new surroundings. He steps cautiously around the periphery of a few free-range white chickens. (Wade recently lost a rooster to a chicken hawk and needed another.) I glance at my watch. It's 1:29. I have a headache, and it's still early. There's time for a treatment. Wade agrees to this, and I remove my visor cap so he can place his hand firmly on the crown of my head.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA61.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.62.1.3.box.177.1201.1372.427.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA61.w.2.2.0"
    }
  }), _vm._v("As Wade prays softly in French, I feel heat from his hand as the chickens cluck, scratching and pecking. Then Wade begins to make the sign of the cross repeatedly down the front of my body, without touching my T-shirt or jeans. As he bends his knees to lower himself, he continues to mutter French prayers. When he's reached my dusty boots, he straightens and walks around me to repeat the treatment down my back, still without touching me.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA61.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.62.1.4.box.178.1644.1371.545.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA61.w.2.3.0"
    }
  }), _vm._v("Barely a minute passes before he finishes. We watch T'Rouge as he joins the hens and begins to scratch and peck with them. You don't thank a "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("traiteur- ")]), _vm._v("thanking is believed to negate a treatment— and I don't as we walk slowly through the field, past his sheep at the trough, and on through the wooden swing gate to the path away from the barnyard. As we pass his old cypress farmhouse, headed toward my pickup, I realize my headache is gone. I smile, wave, and drive away back toward Leonville and my own farm along Bayou Teche.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.62.2.0.box.228.2271.623.43.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA61.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.62.2.0.box.228.2271.623.43.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA61.w.3.0.0"
    }
  }), _vm._v("*A Cajun faith healer or \"treater.\"")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.62.3.0.box.1247.2397.300.31.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA61.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.62.3.0.box.1247.2397.300.31.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA61.w.4.0.0"
    }
  }), _vm._v("— "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Karen ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Yochim ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA62"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA62.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA62.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA62.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA62.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA62"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.63.1.0.box.178.264.1373.2175.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA62.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.63.1.0.box.180.264.306.88.q.40"
    }
  }, [_vm._v("1:33P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA62.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.63.1.1.box.178.443.1372.490.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Easter ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Sunday ")]), _vm._v("2003. The planet in turmoil. A fast-food emporium on Canal Street in New Orleans. The line six deep. As it moves ever so slowly a guy who is obviously a European, dressed casually as if he were off to a hike as opposed to melting in Dixie, stands incredulous at the ballet of American culture unfolding before him. Every few seconds, he turns with pleading eyes to commiserate with his fellow travelers telepathically, or just to make sure this is actually happening or had he lost his mind?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA62.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.63.1.2.box.178.949.1372.350.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA62.w.2.1.0"
    }
  }), _vm._v("Behind the counter seven employees hover in a state that resembles mannequins trapped in Jell-O. Everyone in the line has seen this ritual many times but our European friend seems at a loss as to what it is he can do. He just wants it to work. Most people are acquainted with the express line in modern society. This is the Zen line.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA62.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.63.1.3.box.179.1325.1369.106.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA62.w.2.2.0"
    }
  }), _vm._v("\"Wheah ya from?\" asks the woman waiting in line ahead of him. \"My name is Chawlene.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA62.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.63.1.4.box.179.1448.1371.236.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA62.w.2.3.0"
    }
  }), _vm._v("His name is Dieter and he is from Germany. He is on his way to the Lil' Cajun Swamp Tour; the shuttle is about to pick him up at the Marriott around the corner. Chawlene asks rambling friendly questions.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA62.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.63.1.5.box.229.1701.964.46.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA62.w.2.4.0"
    }
  }), _vm._v("\"I work at the D-Day Museum. Ya seen it yet?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA62.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.63.1.6.box.230.1762.467.36.q.70"
    }
  }, [_vm._v("Dieter shakes his head.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA62.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.63.1.7.box.230.1827.1286.46.q.50"
    }
  }, [_vm._v("Chawlene asks him if he has any favorite local musical groups.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA62.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.63.1.8.box.179.1889.1371.160.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA62.w.2.5.0"
    }
  }), _vm._v("Dieter answers in short jabs of English. It's like Goethe reading "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("A ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Confederacy ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Dunces ")]), _vm._v("with tweezers. He says, \"The New Leviathan Oriental Fox Trot Band.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA62.w.1.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.63.1.9.box.230.2078.1163.46.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA62.w.2.6.0"
    }
  }), _vm._v("\"Neva hoid a dat one, honey. But I'm shuyah dey good.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA62.w.1.10.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.63.1.10.box.230.2140.786.45.q.70"
    }
  }, [_vm._v("Chawlene's order arrives. She departs.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA62.w.1.11.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.63.1.11.box.230.2202.417.48.q.70"
    }
  }, [_vm._v("\"Have a good time.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA62.w.1.12.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.63.1.12.box.179.2266.1372.173.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA62.w.2.7.0"
    }
  }), _vm._v("\"Thank you,\" says Dieter, who by now is mesmerized by the mercantile tableau in front of him. The pace of service moves at cruise control at best. With the parking brake on.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA63"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA63.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA63.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA63"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.64.1.0.box.177.253.1374.1987.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA63.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.64.1.0.box.229.253.581.33.q.80"
    }
  }, [_vm._v("Dieter arrives at the counter.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA63.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.64.1.1.box.177.315.1372.112.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA63.w.1.1.0"
    }
  }), _vm._v("The cashier, Kendra, asks if he would like to try \"the double combo number five with large fries.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA63.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.64.1.2.box.178.442.1371.99.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA63.w.1.2.0"
    }
  }), _vm._v("\"One five-piece chicken nuggets,\" says Dieter. He pays, steps aside to wait.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA63.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.64.1.3.box.177.570.1372.171.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA63.w.1.3.0"
    }
  }), _vm._v("The nuggets are already cooked. They are three feet away at best, visible to all. The other employees continue the fine art of animated nonchalance. This is performance art, perhaps \"A Forest of Mimes.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA63.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.64.1.4.box.177.758.1374.289.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA63.w.1.4.0"
    }
  }), _vm._v("Kendra takes the next order. Dieter stands at the right of the next customer, quiet as a painting at the Louvre. He is a perfect example of placidity at war with itself. Whenever his eyes meet those of another would-be diner, his gaze silently pleads for some explanation of this surrealism.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA63.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.64.1.5.box.177.1076.1372.235.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA63.w.1.5.0"
    }
  }), _vm._v("Still, no one moves to his chicken. At some point during the construction of the next order it occurs to Kendra that perhaps she could fill Dieter's order and the next at the same time. She places his five nuggets into a cardboard pouch, puts the pouch in a bag.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA63.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.64.1.6.box.178.1326.1371.111.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA63.w.1.6.0"
    }
  }), _vm._v("Does she then give them to him? She does no such thing. She puts them on the counter approximately one foot from him.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA63.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.64.1.7.box.178.1454.1372.237.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA63.w.1.7.0"
    }
  }), _vm._v("Does he grab his order? He does no such thing. He does not betray hope of imminent delivery. He is prepared to wait until whenever it is that civilized people wait. To do otherwise would be aggressive. He is doing it for world peace.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA63.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.64.1.8.box.177.1707.1372.159.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA63.w.1.8.0"
    }
  }), _vm._v("Alas, the next diner in line is an American. The interventionist will out. He reaches over the counter and picks up Dieter's order and hands it to him.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA63.w.1.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.64.1.9.box.228.1895.635.39.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA63.w.1.9.0"
    }
  }), _vm._v("\"For me?\" Dieter asks, startled.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA63.w.1.10.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.64.1.10.box.228.1958.386.47.q.60"
    }
  }, [_vm._v("\"For you,\" he says.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA63.w.1.11.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.64.1.11.box.177.2018.1373.222.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA63.w.1.10.0"
    }
  }), _vm._v("Dieter walks out, chicken in hand, dissolving into the humid air and foot traffic on Canal Street beneath a giant fluorescent sign declaring, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"Bienvenue ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("la ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Nouvelle-Orleans. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Laissez ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("les ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("bons ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("temps ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("rouler.")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\" ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.64.2.0.box.1105.2333.445.46.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA63.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.64.2.0.box.1105.2333.445.46.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA63.w.2.0.0"
    }
  }), _vm._v("- ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Christian ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Champagne ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA64"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA64.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA64.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA64.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA64.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA64"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.65.1.0.box.176.254.1377.2172.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA64.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.65.1.0.box.180.254.308.88.q.40"
    }
  }, [_vm._v("1:34P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA64.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.65.1.1.box.176.432.1374.542.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Olivia's ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Got ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("A ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Snowball's ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Chance ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("In ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Hell ")]), _vm._v("at ever tasting the daily special —club sandwich, fries, and Coca-Cola for only sixty-five cents. The cup of coffee sitting before her literally took an act of Congress to receive. Now it sits cold, and until today it was the only thing black the waitress had ever served. Olivia stares at the clock, just above the glass display of lemon meringue pies (sure'd be tasty with that special), and thinks it must be broken. One thirty-seven. Haven't they been here forever and a day? The waitress certainly seems to think so.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA64.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.65.1.2.box.179.1001.1371.357.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA64.w.2.1.0"
    }
  }), _vm._v("Forget the clock and look at something else, she determines, but not at her friends. Surely, they will see how weak she is —see her fear. The glass shaker of sugar goes unnoticed and so will she. Olivia sits and stares at the white crystals and tries to forget the white folks, hoping to sweeten the moment, wishing she could be as white as the sugar, if only for this minute.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA64.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.65.1.3.box.180.1374.1372.363.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA64.w.2.2.0"
    }
  }), _vm._v("It was the Reverend's fault that she was here. He'd whipped the congregation into a righteous frenzy last Sunday with his talk of \"taking our place at the table.\" Of course Olivia clapped and sang and wept for a better seat at that table, but it was Bobby Farrell she really wanted to sit next to, and if he was willing to go to Baton Rouge and see about getting a cup of coffee, so would she.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA64.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.65.1.4.box.181.1751.1372.675.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA64.w.2.3.0"
    }
  }), _vm._v("Olivia's head-over-heels clumsy for Bobby Farrell. But it's high time for her to snap out of it, or so her mother reminds her. It is one thing to get the stupids around a boy, say, in high school. But she is two years into college and studying to be a teacher—just what kind of example will she set for her students if she keeps walking into walls every time Mister Pretty Boy comes around ... or so her mother thinks. Well, maybe Momma's right. Surely being here in this diner right now is flirtin' with the stupids, even riskier than Bobby's \"oh I love ya baby\" maneuvers in the backseat of a car. But she'd gladly risk her virtue just to be away from the angry stares; hell, right about now she'd give anything just to be headed home"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA65.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.66.1.0.box.179.253.1370.111.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA65"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA65.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA65.w.1.0.0"
    }
  }), _vm._v("\nwith or without Bobby, safe at the back of the bus and this time enjoying the fumes.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA65.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA65"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.66.1.0.box.177.253.1373.1628.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA65.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.66.1.1.box.178.382.1372.422.q.60"
    }
  }, [_vm._v("Tempted as she is to see if the clock's minute hand has moved forward, she remains focused on the sugar shaker with its greasy smudges all about it and the slightly damp crust of sugar that puckers the lip of the shaker. You'd think the damn waitress could clean it now and then —sure wouldn't wanna see her home, a real pigsty she bets. Don't worry, Olivia thinks, I wouldn't wanna drink from any water fountain after you either.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA65.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.66.1.2.box.177.822.1373.362.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA65.w.1.2.0"
    }
  }), _vm._v("Sitting stock still, despite the stool's ever wobbling tilt to the right, Olivia's bottom is numb and her feet have gone to sleep. Her neck is downright stiff from her vigilant watch over the shaker. She no longer smells the country fried steaks or the charred bits of ground beef crisping on the grill; all she smells is the starch melting from her dress. Fear pours down her back.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA65.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.66.1.3.box.227.1202.391.46.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA65.w.1.3.0"
    }
  }), _vm._v("How much longer?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA65.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.66.1.4.box.177.1265.1372.616.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA65.w.1.4.0"
    }
  }), _vm._v("\"I've waited a long time for this cup of coffee,\" comes a voice seated to her left. And then, just like that, a hand covers hers. A bit bony, very wrinkled, dark as earth, and etched with talcum powder, maybe Wind Song —she would smell her own hand later to find out. The sugar spell is broken. The clock will resume ticking, Bobby Farrell will continue to dog her, mature into a good husband and father, and her teaching certificate will provide a career of mentoring . . . but for now, all that matters is this old woman and the comfort of her hand. And not wanting to wait, as the old woman has for so many years, Olivia orders two slices of lemon meringue pie.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.66.2.0.box.1227.1960.322.47.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA65.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.66.2.0.box.1227.1960.322.47.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA65.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Debbie ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Lindsey ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA66"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA66.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA66.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA66.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA66.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA66"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.67.1.0.box.177.252.1374.2173.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA66.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.67.1.0.box.180.252.304.88.q.50"
    }
  }, [_vm._v("1:37 P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA66.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.67.1.1.box.177.432.1371.109.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Mass ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Of ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("People ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Is ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Stomping ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Together ")]), _vm._v("on the pavement, but their rhythm is retarded.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA66.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.67.1.2.box.178.557.1371.288.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA66.w.2.1.0"
    }
  }), _vm._v("The parade is marching down Rampart Street, indolently — much like toothpaste being forced from a bottle: lots of pressure from behind forcing the movement of the parade down, what appears, a narrow passage. The street is broad but the amount of people make it confined.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA66.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.67.1.3.box.179.873.1371.110.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA66.w.2.2.0"
    }
  }), _vm._v("The road is dirty: pollution and population. The heat is swelling the smell of sewage. No serious brushing will clean this mess.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA66.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.67.1.4.box.229.1000.1237.47.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA66.w.2.3.0"
    }
  }), _vm._v("Everyone is celebrating Martin Luther King Day a day early.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA66.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.67.1.5.box.178.1063.1373.353.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA66.w.2.4.0"
    }
  }), _vm._v("A horse clip-clops down the center median. The rider, a squat black man, holds the reins in one hand and a half-empty bottle of Jack Daniel's in the other. He tugs the reins left, then right. The horse maneuvers drunkenly, but it's not the horse, it's the rider. He takes a pull from the bottle, spilling it into his throat and slamming it down. The air is thick, but he sweats from the alcohol.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA66.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.67.1.6.box.180.1438.1371.361.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA66.w.2.5.0"
    }
  }), _vm._v("The clopping is echoing into the ears of a young black man with a natty Afro. He is walking in front of the horse. The young black man is focused on accomplishing something in his hands. The horse darts forward. The squat black man is jarred by the jolt. A dram from the bottle splatters on the pavement. The young black man scoots, agilely, to the sidewalk, claiming safety when he gets there.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA66.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.67.1.7.box.180.1815.1371.360.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA66.w.2.6.0"
    }
  }), _vm._v("He returns to the objects in his hands. There is a strike; it's a match. He lights the joint. The smell of marijuana permeates the air. It blends into the whirling smoke billowing from the lungs of a man behind him: middle-aged, bedraggled, with a blunt the size of a large carrot in his mouth. They walk together, in stride, the one behind the other, blowing smoke into the air.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA66.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.67.1.8.box.180.2192.1371.233.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA66.w.2.7.0"
    }
  }), _vm._v("Two gay men follow the footsteps of the pot-smoking men. They come together, take a deep breath of the pleasure cloud, and clench each other's hands. The one with the mustache kisses the cleanshaven, after-shave-dampened cheek of his lover. A middle-class"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA67.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.68.1.0.box.178.254.1372.111.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA67"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA67.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA67.w.1.0.0"
    }
  }), _vm._v("\nwhite boy walks awkwardly along the sidewalk, on the outskirts of the parade.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA67.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA67"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.68.1.0.box.178.254.1372.426.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA67.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.68.1.1.box.178.382.1371.298.q.60"
    }
  }, [_vm._v("Everyone's feet keep stomping, step after step, down the street, grinding and crushing grime into the crevices of the concrete. Each foot claims its position when it stamps down but knows its place. It knows it won't be there long. It will keep trudging on, right into Martin Luther King Day and beyond.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.68.2.0.box.1215.761.335.34.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA67.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.68.2.0.box.1215.761.335.34.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA67.w.2.0.0"
    }
  }), _vm._v("- L. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Scott ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Connor ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA68"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA68.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA68.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA68.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA68.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA68"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.69.1.0.box.177.264.1373.2176.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA68.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.69.1.0.box.180.264.306.88.q.40"
    }
  }, [_vm._v("1:45P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA68.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.69.1.1.box.177.445.1372.299.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Boy ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Is ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Sitting ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("In ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Terrace ")]), _vm._v("of the Superdome, thirty-five rows up. The Saints are winning this Sunday, and this is quickly becoming the norm. His long, floppy blond hair brushes over the shoulder of his Dalton Hilliard jersey as he leans forward in anticipation of the next play.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA68.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.69.1.2.box.178.761.1370.235.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA68.w.2.1.0"
    }
  }), _vm._v("A man emerges from the tunnel at the bottom of the section. He is of average height and medium build and has light brown hair. He is wearing a suit and smiling at the entire section above him, waving to everyone slowly, back and forth.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA68.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.69.1.3.box.178.1012.1371.238.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA68.w.2.2.0"
    }
  }), _vm._v("The boy realizes that this man is David Duke. What the boy knows about Duke is that he used to be in the KKK and is running for office. Duke is on the news often in the boy's home and is generally not approved of by anyone he knows.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA68.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.69.1.4.box.177.1266.1371.231.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA68.w.2.3.0"
    }
  }), _vm._v("An idea suddenly switches on in the boy's mind. As he silently commits to it, he begins to get nervous. He tells his uncle seated next to him that he'll be back in a minute as he gets up and moves past into the aisle.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA68.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.69.1.5.box.178.1514.1371.234.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA68.w.2.4.0"
    }
  }), _vm._v("The boy begins the long, thirty-five-row descent toward the average-sized man, still happily shaking hands and waving below. His heart begins to beat heavily. He quickly considers giving it up and returning to his seat.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA68.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.69.1.6.box.228.1764.432.47.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA68.w.2.5.0"
    }
  }), _vm._v("The boy keeps going.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA68.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.69.1.7.box.178.1828.1372.160.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA68.w.2.6.0"
    }
  }), _vm._v("As he nears the bottom of the stairs, he considers walking past the average-looking man and on to the bathroom. He thinks to himself that it isn't too late to abort.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA68.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.69.1.8.box.178.2016.1371.172.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA68.w.2.7.0"
    }
  }), _vm._v("The boy steps down the last stair and onto the landing with the average man. His heart pounding inside of his sternum, the boy looks up at the man to catch his eye.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA68.w.1.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.69.1.9.box.178.2204.1370.97.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA68.w.2.8.0"
    }
  }), _vm._v("The average man sees the boy, smiles down at him, and says, \"Hello.\" The man offers his hand.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA68.w.1.10.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.69.1.10.box.179.2330.1370.110.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA68.w.2.9.0"
    }
  }), _vm._v("The boy hesitates for"), _c('a', {
    attrs: {
      "id": "GBS.PA68.w.3.0.0"
    }
  }), _vm._v(" a moment. His hands are quivering. He loo"), _c('a', {
    attrs: {
      "id": "GBS.PA68.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA68.w.3.2.0"
    }
  }), _vm._v("ks up into the man's eyes and says, \"You suck.\"")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA69"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA69.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA69.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA69"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.70.1.0.box.177.253.1370.425.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA69.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.70.1.0.box.177.253.1370.173.q.60"
    }
  }, [_vm._v("The man's face twists up. The corners of his mouth turn down rigidly as his eyes narrow in anger. For a moment, the boy is afraid of the man's private display of naked rage.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA69.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.70.1.1.box.177.440.1370.238.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA69.w.1.1.0"
    }
  }), _vm._v("The man withdraws his hand. The boy sees the corners of his mouth move higher as the man turns back toward the crowd. The average man begins to wave up at the section, offering a hollow, plastic smile.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.70.2.0.box.1187.759.362.41.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA69.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.70.2.0.box.1187.759.362.41.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA69.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("James ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("L. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Jones ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("III ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA70"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA70.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA70.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA70.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA70.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA70"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.71.1.0.box.178.260.1373.2173.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA70.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.71.1.0.box.180.260.286.86.q.40"
    }
  }, [_vm._v("1:51P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA70.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.71.1.1.box.178.438.1370.236.q.50"
    }
  }, [_vm._v("L. A. "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Norma ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Stood ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("On ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Stone ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Floor ")]), _vm._v("of Amtrak's waiting room, on Loyola Avenue, and blew a plume of Camel cigarette smoke into the face of a young woman named K. O. We awaited the Station Master's call for "), _c('i', [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("City ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Orleans. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA70.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.71.1.2.box.178.689.1370.173.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA70.w.2.1.0"
    }
  }), _vm._v("A ")]), _vm._v("security guard stood near the ticket desk. He held a mediumsized yellow plastic bucket. Around its lip, in three-inch red Magic Marker lettering, was \"Homeland Security.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA70.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.71.1.3.box.178.877.1370.237.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA70.w.2.2.0"
    }
  }), _vm._v("\"The best thing about Bloomsday is that none climb too far out on the limb of understanding it,\" Norma said, as the guard pushed the yellow bucket under her chin. The bucket was filled with sand. \"Smokin' ain't allowed here, lady,\" he said.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA70.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.71.1.4.box.179.1128.1369.164.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA70.w.2.3.0"
    }
  }), _vm._v("Norma pushed the cigarette from her lips with her tongue. It fell atop the sand with a soft plop. The guard thanked her and turned back toward the desk.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA70.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.71.1.5.box.179.1317.1371.360.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA70.w.2.4.0"
    }
  }), _vm._v("We were on our way to Jackson, Mississippi and the exhibition, \"The Glory of Baroque Dresden.\" K. O. and her boyfriend, O. K., were on their way back home to Memphis. We had met the night before at O'Flaherty's celebration of James Joyce's obtuse novel. The bar had been crowded, it being the one-hundredth Bloomsday, and the two had squeezed in at our table.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA70.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.71.1.6.box.179.1694.1371.424.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA70.w.2.5.0"
    }
  }), _vm._v("K. O. sported purple hair, one gold nose ring, and two glass chandelier earrings made from tiny red and green crystal crosses. Her fellow traveler, O. K., was similarly colored and pierced, with six gold earrings in his right ear and one in the left. They each carried a string bag with six bottles of Stone Cellars red wine. We all watched the security guard navigating back to the ticket desk, a trail of smoke issuing from his yellow bucket.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA70.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.71.1.7.box.180.2135.1369.108.q.50"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA70.w.2.6.0"
    }
  }), _vm._v("'The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("City ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("New ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Orleans, ")]), _vm._v("an adventure in slow motion,\" O. K. said as we boarded. It wasn't clear if he meant the train or the city.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA70.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.71.1.8.box.179.2260.1372.173.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA70.w.2.7.0"
    }
  }), _vm._v("The doors clattered closed and we slipped out past the Arena and Superdome. The Superdome looked like the box the Arena had come in. At town's edge, we rocked over marshland of blue channels"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA71.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.72.1.0.box.178.253.1368.99.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA71"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA71.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA71.w.1.0.0"
    }
  }), _vm._v("\ndotted with clumps of thick green grasses that came right up to the roadbed.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA71.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA71"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.72.1.0.box.177.253.1370.605.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA71.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.72.1.1.box.177.382.1370.108.q.70"
    }
  }, [_vm._v("\"That's the quicksand from which Tarzan was always pulling stumbling British explorers,\" Norma told us.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA71.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.72.1.2.box.177.506.1370.352.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA71.w.1.2.0"
    }
  }), _vm._v("\"One day the whole Big Easy will be sucked down into some giant clump of marsh grass,\" O. K. said, passing a wine bottle. We ate Chicago pizza in the diner and saw manmade ponds alongside the tracks. The ponds were filled with manmade catfish, watched over by long-necked white egrets. We were gliding up the gentle incline of America's old Continental Shelf.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.72.2.0.box.1108.950.437.44.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA71.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.72.2.0.box.1108.950.437.44.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA71.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Leonard ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Earl ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Johnson ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA72"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA72.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA72.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA72.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA72.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA72"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.73.1.0.box.178.266.1373.2173.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA72.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.73.1.0.box.180.266.302.86.q.40"
    }
  }, [_vm._v("1:55 P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA72.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.73.1.1.box.178.445.1371.677.q.50"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("My ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Office ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("On ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Second ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Floor ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Of ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("City ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Hall ")]), _vm._v("is so big I could do a cartwheel. Not that I ever have. This is where I write letters —to be signed "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("C. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Ray ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Nagin ")]), _vm._v("- at a veneered, L-shaped desk. But right this minute I'm swiveled toward the floor-to-ceiling windows instead. It's two in the afternoon and the sky is the same drab gray as the carpet. Soon, the heavens will open up, and Poydras Street will flood all the way up to the end of the Supe"), _c('a', {
    attrs: {
      "id": "GBS.PA72.w.2.1.0"
    }
  }), _vm._v("rdome. I glance at my IN basket, which I've already been through. A family got evicted from their project apartment, a man wants to add on to his house in Treme, a woman's son was murdered, and no one's doing anything about it. Including me.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA72.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.73.1.2.box.180.1139.1369.295.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA72.w.2.2.0"
    }
  }), _vm._v("\"Why you in the dark?\" The director of administration appears in the doorway; the buttons on her purple business jacket might pop any second under the force of her great bosom. When she flicks the lights on and off, it leaves long blue tracks in my vision, the same shape as the fluorescent tubes on my ceiling.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA72.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.73.1.3.box.230.1450.755.46.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA72.w.2.3.0"
    }
  }), _vm._v("\"Oh, I prefer the natural light,\" I say.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA72.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.73.1.4.box.179.1513.1371.235.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA72.w.2.4.0"
    }
  }), _vm._v("\"Well, there isn't any today.\" She turns the lights on again. \"Hey, when you write a letter to da guvna, use the nice paper,\" she advises, shaking one of the masterpieces I created yesterday on the flimsier letterhead. The guvna? Oh, the governor.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA72.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.73.1.5.box.179.1764.1372.549.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA72.w.2.5.0"
    }
  }), _vm._v("\"Yeah, I'm coming,\" she says to someone down the hall. \"You know,\" she says to me, \"there's barbecued shrimp in there.\" I know about it because the director of scheduling, the finance officer, the deputy director of administration, the receptionist, the summer intern, and the guy who cleans the bathroom have already told me. I'm allergic to shrimp, crawfish too. I tell them this every time someone sends over a vat of whatever to put out in the conference room. Still, they come in every time, one by one, to ask why I'm not in there eating it.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA72.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.73.1.6.box.181.2330.1370.109.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA72.w.2.6.0"
    }
  }), _vm._v("They want to feed me because I'm a Yankee, I think. I seem a little cold, like I could use a hot lunch. They tell me I shouldn't be"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA73.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.74.1.0.box.179.252.1369.237.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA73"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA73.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA73.w.1.0.0"
    }
  }), _vm._v("\ndrinking that Diet Coke, that I need to try some baked macaroni. That'll put some meat on my bones. On my first day here, I went up to the window in that marble hallway on the first floor, where you go when you're new to get an employee ID.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA73.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA73"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.74.1.0.box.177.252.1372.1374.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA73.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.74.1.1.box.179.505.1370.160.q.40"
    }
  }, [_vm._v("\"You got a Social Security number that starts with 1-9-1,\" said the plump man behind the glass. \"Are you from New "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Yaivk ")]), _vm._v("er somethin'?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA73.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.74.1.2.box.229.695.533.47.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA73.w.1.2.0"
    }
  }), _vm._v("\"Pennsylvania,\" I blinked.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA73.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.74.1.3.box.178.758.1370.98.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA73.w.1.3.0"
    }
  }), _vm._v("\"Hey,\" he yelled to his co-workers, \"the new mayor's hiring "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("girls ")]), _vm._v("from New "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Yawkl\" ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA73.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.74.1.4.box.177.886.1372.551.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA73.w.1.4.0"
    }
  }), _vm._v("Well I'm sorry, but I can't eat shrimp, and I'm too sleepy to get anything done. I know the coffee maker in the kitchen isn't working, so I walk down the hall to the mayor's waiting room, where there's nice furniture and a big glass candy bowl with a gaping rim. It's been filled so high a few stray pieces have fallen around it on the dark wood table. I check to make sure no one's around, then I dig my hand down deep, separating the cheap candy from the rich chocolate by touch, judging by the smoothness of the wrappers. When I'm satisfied with my fistful, I withdraw upward, a bicep curl.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA73.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.74.1.5.box.178.1453.1370.173.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA73.w.1.5.0"
    }
  }), _vm._v("\"Sweetheart,\" says a man's voice. I reel around. \"You know we're in the middle of a budget crisis?\" The mayor's head gleams. My face goes pink.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.74.2.0.box.1246.1708.303.33.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA73.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.74.2.0.box.1246.1708.303.33.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA73.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cristina ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Black ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA74"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA74.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA74.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA74.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA74.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA74"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.75.1.0.box.178.266.1374.2173.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA74.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.75.1.0.box.180.266.322.88.q.80"
    }
  }, [_vm._v("2:00 P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA74.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.75.1.1.box.178.443.1374.1180.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("It's ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Two ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("O'clock ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("On ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Friday ")]), _vm._v("and Scott Kupper is leaning on his truck parked on the corner of Railroad and Pine. It's a good location. From here he can watch for potential customers coming out of Paul's Cafe and tourists visiting Ole Hardhide's wire cage. Friday is alligator feeding day and Dave Opdenhoff has just served Ole Hardhide's dinner of raw chickens and driven off in the city water truck. Now Scott watches as a tall brunette in a denim skirt dashes across the railroad tracks toward him. \"They're beautiful,\" she says, pointing to the white cardboard boxes arranged on the tailgate of his 1990 Chevy truck. Ten years ago Scott and his daddy built the metal and plywood frame that arches over this pale blue truck and Scott stenciled the red and green \"Kupper Farm Strawberries\" himself. The boxes are filled with strawberries . . . succulent, perfect berries every one ... emitting a fragrance like no other in the world. \"How much for a half-flat?\" the woman asks. When he tells her eight dollars, she says it's a good price for mid-March. Scott smiles. It's not about the money. He's only a hobby farmer with two acres of plants behind his yellow house. He works for the Department of Agriculture, but that's not all about money either.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA74.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.75.1.2.box.180.1638.1372.602.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA74.w.2.1.0"
    }
  }), _vm._v("He's thirty-seven, quite handsome, with hair the color of rich dirt, a mustache and neatly trimmed beard to match. Straight white teeth and a ready smile. A sturdy frame; legs like fence posts. He wipes his hand on his T-shirt advertising Woody's Ukulele Shop. \"Come play with us,\" the shirt invites passersby. Scott knows strawberry farming isn't playing. It's hard work, planting, picking, cutting, cleaning. There are the years of fighting insects, years Mother Nature sends late frosts or too much rain, the years of prices going down so low he can barely afford the plastic mulch he spreads on the field.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA74.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.75.1.3.box.182.2266.1370.173.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA74.w.2.2.0"
    }
  }), _vm._v("But, it's not all about work. There's euphoria, too, he thinks, as he offers the lady a berry to taste. Juice trickles down her chin and they both laugh. \"Sweet,\" she says. He tells her that strawberries are the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA75.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.76.1.0.box.178.251.1372.870.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA75"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA75.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA75.w.1.0.0"
    }
  }), _vm._v("\naphrodisiac he learned to love in his infancy. To Scott, strawberry farming is all about the wonder of watching something so tiny grow into a twelve-inch-high bush. A rosebush actually. Strawberries are really swollen pistils of seeds in the rose family, he tells the lady, but he knows that nobody cares about that except people like him. And his daddy, who was a bona fide strawberry farmer with twenty-five acres of straight rows you could run a plumb line down. In the 1990s his daddy set up shop on this very spot beside the railroad tracks in Ponchatoula and taught Scott that the really interesting thing about selling isn't the product, it's the people. You have to like people to sell, Scott tells his own son. You can't learn to appreciate life watching television and playing video games. You've got to get out in the fields where Mother Nature will cure your blues, he says. But Scott knows those mournful blues aren't cured so easily.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA75.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA75"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.76.1.0.box.178.251.1372.1375.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA75.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.76.1.1.box.178.1136.1372.490.q.60"
    }
  }, [_vm._v("As the woman walks away carrying her box of berries like an offering, Scott looks down the tracks and swallows twice. He's standing where just last year Mama sat in a lawn chair selling her berries. She wasn't feeling so good that day, and she closed up shop and walked away. Diabetic coma, they said. Never felt a thing when she fell on the tracks just as the train came through. He pockets the five and three ones the brunette paid him and whispers, \"No, it's not about the money.\"")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.76.2.0.box.1263.1707.285.35.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA75.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.76.2.0.box.1263.1707.285.35.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA75.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Bev ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Marshall ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA76"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA76.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA76.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA76.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA76.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA76"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.77.1.0.box.177.252.1374.2173.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA76.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.77.1.0.box.180.252.320.88.q.50"
    }
  }, [_vm._v("2:09P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA76.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.77.1.1.box.177.432.1372.552.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Day ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Is ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Sunny ")]), _vm._v("and unseasonably hot in this oil-patch town of Lafayette, rejuvenated and rich again after the big \"Oil Bust\" of the 1980s. Mardi Gras is just past and strings of plastic beads still hang from the branches of downtown trees recently planted on a spiffy new pedestrian mall. Around the corner, the long side of a corrugated-steel warehouse is painted with a tidy yellow faux facade just big enough for a bright red door and overhang, a window, and a sign that says Odell Pottery. Inside are Bruce Odell's trophies as a three-time U.S. Pottery Olympics champion.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA76.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.77.1.2.box.179.1001.1370.344.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA76.w.2.1.0"
    }
  }), _vm._v("To the left of a showroom displaying his distinctive vessels, the potter stands outside an open-ended shed that holds shelves of pottery in various stages of completion and strange-looking contraptions that look jerrybuilt from wash pots and oil drums. In another room he has just finished demonstrating how to throw pots on a wheel.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA76.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.77.1.3.box.179.1374.1370.235.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA76.w.2.2.0"
    }
  }), _vm._v("Odell dons firemen's gloves and takes the lid off an oil-drum kiln; the heat intensifies and drops of sweat glisten on his face. His audience, sweating now, too, crowds around to look at the glazed pots inside the orange inferno. \"Don't get too close!\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA76.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.77.1.4.box.179.1625.1372.676.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA76.w.2.3.0"
    }
  }), _vm._v("With immense tongs he snatches a red-hot pot from the glowing furnace and flames it with a concoction of water, corn oil, and alcohol that sprays from a metal wand. A burst of steam and fire soars high in the sky as the pot becomes a blazing torch. Quickly he moves inside to a kind of metal cradle filled with a dark damp pile of sawdust and ashes. It is pure alchemy as the pottery torch is rapidly manipulated with the wand and then buried for a moment of time only the alchemist knows. As smoke and flames billow to the ceiling and his wide grin takes on a devilish air, everyone understands why his arms ripple with muscles and his black T-shirt says \"Pyromaniac.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA76.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.77.1.5.box.180.2317.1371.108.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA76.w.2.4.0"
    }
  }), _vm._v("\"This is raku, invented by the Japanese. But I've invented my own color technique. Timing is crucial. If my colors don't come out just"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA77.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.78.1.0.box.178.255.1371.238.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA77"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA77.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA77.w.1.0.0"
    }
  }), _vm._v("\nright, then I'm tempted to throw the pot at the train,\" he says, laughing. All at once his meaning becomes perfectly clear when with that ear-piercing wail that lures wanderers to leave home a freight train roars past the shed almost close enough to touch.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA77.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA77"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.78.1.0.box.177.255.1372.666.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA77.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.78.1.1.box.177.508.1372.413.q.60"
    }
  }, [_vm._v("As the train rushes by, its cry vocalizing loneliness, the gloved hands carefully lift the smoking pot from the ashes and plunge it into a bucket of water. It takes less than a minute for the train to pass, and when it does, he is holding up a new creation, no longer humble gray clay, but a rainbow of glittering, metallic color forged into a crucible of beauty — magic made from fire and air and water and this Louisiana earth.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.78.2.0.box.1243.1015.304.35.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA77.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.78.2.0.box.1243.1015.304.35.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA77.w.2.0.0"
    }
  }), _vm._v("-Mar")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("da ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Burton ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA78"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA78.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA78.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA78.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA78.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA78"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.79.1.0.box.177.250.1373.1171.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA78.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.79.1.0.box.180.250.290.88.q.40"
    }
  }, [_vm._v("2:11P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA78.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.79.1.1.box.177.432.1373.423.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Old ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Gentlemen ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Sit ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("On ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Franklin ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Avenue's ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Neutral ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Ground ")]), _vm._v("in folding chairs and drink coffee and beer. They wear dress pants with short-sleeve shirts and jaunty caps. The smoke from their cigarettes rises like halos around their heads and caresses the limbs of the crepe myrtle tree above them. Occasionally, one of them gestures with a finger as he speaks and then they all throw their heads back and laugh.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA78.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.79.1.2.box.178.872.1371.236.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA78.w.2.1.0"
    }
  }), _vm._v("The old gentlemen are the guardians of the neighborhood. You can walk up to them and ask them any question, like \"Where can you buy the best men's undershirts?\" or \"Who's sleeping with the pastor's wife?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA78.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.79.1.3.box.178.1126.1371.110.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA78.w.2.2.0"
    }
  }), _vm._v("And they pause for a second, stare at you, and then the guy in the Saints cap with the Miller Pony in his hand answers:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA78.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.79.1.4.box.179.1252.1371.169.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA78.w.2.3.0"
    }
  }), _vm._v("\"Old Chinese guy on St. Claude near the junk store has the best price on shirts and you better talk to Eugene here about your other question.\"")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.79.2.0.box.1110.1501.441.33.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA78.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.79.2.0.box.1110.1501.441.33.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA78.w.3.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Donna ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Maria ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Bonner ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA79"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA79.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA79.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA79"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.80.1.0.box.178.264.1373.2053.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA79.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.80.1.0.box.182.264.324.88.q.40"
    }
  }, [_vm._v("2:22P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA79.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.80.1.1.box.178.445.1373.1872.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA79.w.2.0.0"
    }
  }), _vm._v("POSTED FADED YELLOW SIGN HANGS ON THE TERMITE-cHEWED POST in Pointe Coupee Parish. Wild wisteria vines twist into a carpet covering the porch. A wooden porch swing, with remnants of white paint, dangles from one rusted chain. A woman in full, long-sleeved white dress, beads of humid sweat formed around her lips, sits on the swing. Softly humming, gently rocking a child into a nap. A beaten swollen dark wood door has sealed itself into the threshold. Two lengthy windows are frameless and paneless. Remnants of thick lead glass twinkle off the floor. Ribbons of beaded board float down from the ceiling. Broken bricks and ash gather in the center of a crumbling chimney. A simple unadorned mantel is scarred by scratches of profanity. On the mantel rests a solitary broken figurine blackened by age and soot. A young man places his smoking pipe on a mantel tray. Chicory sweetness drifts into the room. He stoops, prods, stokes a fire for warmth, looks toward the kitchen for food. The kitchen no longer exists. The roof and walls, broken pots, scattered dish pieces lay unburied in milk thistle weeds mixed with pasture grass. A four-legged massive stove has tumbled further, into a colossal southern Oak tree with vine-covered limbs stretching over the land, into the heavens, or rotted fallen onto the earth. A long thick braided rope hangs from one limb. A young girl climbs onto the tree swing, calling for her brother to push her higher, higher. Ribbons hold the fallen bonnet around her neck, her hair flips forward, backward with each push and pull on the braided ropes. Laughter stirs the giant leaves. Which fall toward the ground in a mound of slow decay. The trunk of the tree is gouged and sunken where a limb was pulled away by storm. In the hollow rests a statue of the Virgin Mother. Her eyes chipped away by rain to become a vacant stone glare. Chips of faded blue paint cling on her robe. Her arms are stretched over the haunted grounds where families once stayed.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.80.2.0.box.1175.2396.371.33.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA79.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.80.2.0.box.1175.2396.371.33.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA79.w.3.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Michele ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cushman ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA80"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA80.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA80.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA80.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA80.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA80"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.81.1.0.box.177.260.1374.2175.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA80.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.81.1.0.box.180.260.322.90.q.60"
    }
  }, [_vm._v("2:30 P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA80.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.81.1.1.box.177.442.1372.741.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("On ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Each ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Side ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Of ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Fannin ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Street ")]), _vm._v("in Shreveport, not far from Allen Avenue, half a dozen shotguns sway with each sigh of the afternoon sun. They could fall in upon themselves, be knocked over by a bulldozer making half an effort, or stand as damaged and strong as the occupants some still hold. It makes no difference to them, though standing still seems easiest somehow. The rusted metal or particle roofs threaten to spill into the bushes that squeeze between the structures. The paint, if any still remains, blisters with chronic eczema. The gray of the sinewy bones and clinging paint strips make them look more like their elderly lodgers' hair. The houses and tenants remain weakly rooted, as if in a race to stand at rest and see who lasts longer.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA80.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.81.1.2.box.178.1199.1372.735.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA80.w.2.1.0"
    }
  }), _vm._v("The electrical ropes threaten to pull them off of their foundations by their attic vents, but they don't mind. It hasn't happened yet, and they are not so worried. Overgrown plants, nearly reaching the overhangs of the porches, splay out between them, arching over and covering disjointed stairs that don't even support the ghosts whose arms no longer threaten to reach between the steps and grab at ankles that rarely ascend anymore. They are not lonely; though they sometimes wonder when a breeze from a truck with new tires drives by, slowly, if the stares should matter to them. They decide that new eyes do not matter much more than the old and they remain still. Sometimes they glance at one another, just to make sure the view hasn't changed.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA80.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.81.1.3.box.178.1950.1373.485.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA80.w.2.2.0"
    }
  }), _vm._v("A clothesline is the only suggestion of a life lived for many, stretched across the porch like the stories told there since a time they can no longer recall. One empty, detached facade shows off a white banister set against nothing. It may have been vacant for an hour or fifty years. If someone returns in a moment from whenever "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("now ")]), _vm._v("means, that will be fine with the houses, but they won't mind if no one ever comes back to the off-kilter doors with the rusted hinges. The hinges will be there when someone is ready for them.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA81"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA81.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA81.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA81"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.82.1.0.box.177.255.1374.859.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA81.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.82.1.0.box.177.255.1374.859.q.60"
    }
  }, [_vm._v("Not far from the hinges, colors dot the covered entrances like sprinkles on a cupcake, the lip of the cake pulling away, like siding on a house. Underneath, where the crawdads don't live and never have, there is nothing but grass disappearing into shadow and moisture. While the rest of its skin peels away, lavender mascara stares back from around the windowpanes. Colored towels are draped across shapes containing things they have never thought to uncover. But here, a woman's defiant arm and hand grasp the railing at the top, where the porch meets the steps — and the stairs, like the woman, are wearing their Saturday best: red lipstick on each of their teeth. Her arm remembers the house's name by touch and the woman glares down at the outside interruption of a camera's closing shutter. The shotgun, however made-up, is unmoved by the chance encounter.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.82.2.0.box.1010.1204.540.35.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA81.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.82.2.0.box.1010.1204.540.35.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA81.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Tara ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Schemer ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("de ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("la ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Fuente ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA82"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA82.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA82.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA82.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA82.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA82"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.83.1.0.box.177.258.1376.2161.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA82.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.83.1.0.box.184.258.320.88.q.50"
    }
  }, [_vm._v("2:37 P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA82.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.83.1.1.box.181.440.1371.348.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("She ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Answers ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Door ")]), _vm._v("and greets an old friend. He's on his way to law school and wants to say good-bye. Her four-year-old daughter plays contentedly in the backyard. A calm lull descends as the aroma of red beans and rice drifts out of the open windows. White curtains breathe and ripple noiselessly. There is laughter and reminiscence.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA82.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.83.1.2.box.180.818.1373.427.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA82.w.2.1.0"
    }
  }), _vm._v("Suddenly, a furious knocking. She darts from her puzzled guest and swings open the front door. She stares into the gnarled, weathered face of the black yardman from down the street. They've waved and greeted each other a hundred times the way neighbors do, the way yard workers politely acknowledge the ladies of the neighborhood when they come driving by. Now he has the eyes of a man possessed, muttering unintelligibly.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA82.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.83.1.3.box.180.1260.1370.92.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA82.w.2.2.0"
    }
  }), _vm._v("\"I sho nuff tole 'em dey not takin' dat baby guhl!\" he gasps. \"I sho nuff did!\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA82.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.83.1.4.box.180.1381.1370.111.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA82.w.2.3.0"
    }
  }), _vm._v("Next to him, her small white hand clasped in his huge brown one, stands the child, trembling and crying softly.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA82.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.83.1.5.box.179.1506.1372.299.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA82.w.2.4.0"
    }
  }), _vm._v("And so it happens at a particular moment in this yardman's day —perhaps upon filling his tenth bag of leaves, or carrying the garbage to the bin, or eating his carefully packed brown-bag lunch — that he glances a few houses down and sees two strangers, a man and a woman, leading the girl to an unfamiliar car.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA82.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.83.1.6.box.179.1821.1371.111.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA82.w.2.5.0"
    }
  }), _vm._v("He had a \"spookin',\" he declares breathlessly. In the pit of his stomach, he knew \"dem folks was up to sumptin' bad.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA82.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.83.1.7.box.177.1947.1373.472.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA82.w.2.6.0"
    }
  }), _vm._v("So he sprints down the street. He picks up a tire iron, holds it over his head menacingly, and tells the would-be abductors if they don't turn her loose, he'll \"hit 'em where the sun don't shine.\" He is offered fifty dollars cash to look the other way and go about his business. He declines, to put it mildly. The authorities are called and a report made. The local news features the incident, warning parents to be watchful for a couple who tried to lure a"), _c('a', {
    attrs: {
      "id": "GBS.PA82.w.3.0.0"
    }
  }), _vm._v(" child into a car")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA83"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA83.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA83.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA83"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.84.1.0.box.177.254.1375.1251.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA83.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.84.1.0.box.177.254.1373.555.q.60"
    }
  }, [_vm._v("Later, the girl will have supper and a bath, just like any other night. All around, the stirrings of tomorrow will begin. The neighborhood dogs will be brought in, and the street will get quiet. Dishes will be washed and school clothes laid out. Children will argue, then relent. There will be scurrying and hurrying about. The wail of the tugboats will echo across the Red River, their mournful sound rising and falling. And forty-five miles due south, Confederate and Union casualties of the Battle of Mansfield lie undisturbed under the silent oaks, painless and free.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA83.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.84.1.1.box.229.826.964.46.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA83.w.1.1.0"
    }
  }), _vm._v("Here on Earth, the rituals of the living proceed.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA83.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.84.1.2.box.229.889.708.47.q.70"
    }
  }, [_vm._v("\"Don't forget to brush your teeth.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA83.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.84.1.3.box.229.951.747.48.q.60"
    }
  }, [_vm._v("\"Where did you put my book sack?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA83.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.84.1.4.box.230.1014.580.48.q.70"
    }
  }, [_vm._v("\"Lights out in five minutes.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA83.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.84.1.5.box.230.1079.288.41.q.40"
    }
  }, [_vm._v("\"Yes, ma'am.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA83.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.84.1.6.box.179.1142.1373.235.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA83.w.1.2.0"
    }
  }), _vm._v("Outside, the trees will begin to sway and take on the appearance of huge, benevolent guards standing watch. The trauma of day will ease into blessed rest. And a mother and father will kneel by the side of a bed and offer thanks for the child who was almost gone.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA83.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.84.1.7.box.180.1394.1371.111.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA83.w.1.3.0"
    }
  }), _vm._v("Across town, a tired old black man will warm up his supper, fall asleep in his rocker, and dream.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.84.2.0.box.1208.1582.346.35.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA83.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.84.2.0.box.1208.1582.346.35.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA83.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Leslie ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Alexander ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA84"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA84.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA84.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA84.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA84.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA84"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.85.1.0.box.177.250.1376.2176.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA84.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.85.1.0.box.180.250.322.88.q.50"
    }
  }, [_vm._v("2:39 P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA84.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.85.1.1.box.177.430.1373.426.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("She ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Waits ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("For ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Ma-maw ")]), _vm._v("to pull the gritty brown sock of dark roast from the white porcelain pot. Then she watches as the cotton-haired icon pours meager half-cups, as she does after dinner every day. Finally, her grandmother takes the butcher knife and cuts a square of melting fatback on the stained kitchen counter, where the boys left it, and ties it to the end of the string dangling patiently from the girl's hand. She is not allowed to handle knives.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA84.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.85.1.2.box.179.872.1372.550.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA84.w.2.1.0"
    }
  }), _vm._v("Through the dining room, where the scraped bowls still sit in the afternoon light. Through the living room, where idle conversations hang in the thick smoke. Onto the front porch, where Guppy, the old Catahoula, licks a rusted pan, while Pa-Paw props his feet on the corner post, gnaws a toothpick, and looks out over his barren land. Down the steps and her feet hit the hot dirt that is Paradise, Louisiana. Navigating the great roots and sticker balls of the sweet gum tree, she quickens her pace. The boys are already out of sight. They have arrived there by now.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA84.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.85.1.3.box.180.1436.1371.299.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA84.w.2.2.0"
    }
  }), _vm._v("The honeysuckle beckons with its summer sweet, but she breaks into a run all the way to the cattle gap. There, she carefully places each foot to avoid the maze of concrete holes. Catching her breath, she traverses the gravel, which takes her ultimately to the tiny bridge of the crawdad hole that they call Flaggon Creek.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA84.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.85.1.4.box.181.1749.1372.237.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA84.w.2.3.0"
    }
  }), _vm._v("Dragonflies dance on the emerald glass water. Lush growth of green zigzags through the dead brush. The boys have left the bridge and gone down close to the water, dropping their lines in close to the magic. But she stays on the bridge.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA84.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.85.1.5.box.181.2002.1372.298.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA84.w.2.4.0"
    }
  }), _vm._v("Sitting on the edge, tucking her worn cotton dress between her legs, she drops the baited string down into the silent creek. Dipping her toes into the cool liquid, she smiles. One of the boys has thrown a handful of rocks up to make the telephone wires sing. The others condemn him for breaking the quiet.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA84.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.85.1.6.box.182.2316.1371.110.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA84.w.2.5.0"
    }
  }), _vm._v("A tug on the string. She pulls it too quickly. Part of the fatback is missing. But she will try again. This time she must watch more"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA85.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.86.1.0.box.177.252.1369.178.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA85"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA85.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA85.w.1.0.0"
    }
  }), _vm._v("\ncarefully and not be distracted by the boys. As she waits, a monarch and a buckeye play in the thicket. The heat burns her back, and the bridge warms her bottom, but something will bite soon.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA85.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA85"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.86.1.0.box.177.252.1371.1063.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA85.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.86.1.1.box.177.444.1371.302.q.50"
    }
  }, [_vm._v("The second tug. She gently lifts the string from the water. Delighted, she brings it up to her lap. The crawdad is small. He struggles at the fatback. Afraid to pet him, she whispers to him. Getting on her belly now, she looks closely into his beady black eyes. She giggles. He knows her somehow.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA85.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.86.1.2.box.178.759.1370.301.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA85.w.1.2.0"
    }
  }), _vm._v("\"What you got?\" comes the shout from across the creek. She has to wink an eye to see them in the glare. When she doesn't answer them, the boys trudge up the bank toward the bridge. Still too afraid to touch and pull him from the bait, she contemplates untying the little jagged piece of fat. But Ma-Maw knows how to tie a good knot.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA85.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.86.1.3.box.179.1074.1369.241.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA85.w.1.3.0"
    }
  }), _vm._v("The boys approach the wooden planks of the bridge. She kisses the tail of the crawdad, then lowers the creature safely back into the water. As their feet pound the boards announcing the boys' arrival, she releases the string from her hand.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.86.2.0.box.1115.1392.434.47.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA85.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.86.2.0.box.1115.1392.434.47.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA85.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Patricia ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Ellyn ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Powell ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA86"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.87.1.0.box.177.250.1376.2176.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA86.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.87.1.0.box.180.250.324.88.q.40"
    }
  }, [_vm._v("2:45P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA86.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.87.1.1.box.177.429.1375.1493.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Somewhere ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Inside ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Red ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Three-story ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Building ")]), _c('a', {
    attrs: {
      "id": "GBS.PA86"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA86.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA86.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA86.w.2.0.0"
    }
  }), _vm._v("at the corner of St. Philip and Royal streets, children are warming up their horns, wetting their reeds, snapping on their snares. It's Carnival season, so the fifth and sixth graders in the school band are prepping once again for the school parade through the streets of the French Quarter. After they are done prepping in the band room on the third floor, the band assembles in the rear playground to practice marching. The schoolyard is hidden from the street, shaded by great magnolias and live oaks, and bounded by the brick-and-stucco back buildings —the slave quarters, kitchens, and "), _c('a', {
    attrs: {
      "id": "GBS.PA86.w.2.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA86.w.2.1.0"
    }
  }), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("garconnieres ")]), _vm._v("of Creole townhouses. It smells of sweet olive, sour milk from discarded milk cartons, and Indian bidi cigarette smoke. The band leader is a large-framed, balding black man with a full beard and healthy paunch. He sweats profusely — his forehead glistens, and the underarms of his peach-colored extra-large guayabera shirt are soaked through. He's trying to light a bidi cigarette that keeps going out. It's tough because his paper matches don't stay lit long enough in the breeze. The kids call him \"Mr. Payton.\" One of them rags him about smoking those \"funny numbers\" at school. He ignores it, but gives up on the skinny half-smoked Indian cigarette, fumbling it back into the worn pack in his left chest pocket. \"OK, now,\" he says, standing up straight and surveying the band, \"we lined up?\" The kids, in their white band shirts (the extent of the uniform), look at each other and nod. Mr. Payton nods, too. \"OK. Frank?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA86.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.87.1.2.box.181.1939.1372.487.q.50"
    }
  }, [_vm._v("Frank is the first trumpet, a mop-haired boy, one of the school's handful of white students. He nods and presses his horn to his mouth. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Dee ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("da ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("deeeee-but ")]), _vm._v("the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("da! ")]), _vm._v("that's supposed to punctuate the phrase doesn't come out. He tries it again. No. Again, the last note of the \"Second Line\" clarion call fails to show up. The kids all look at him. Not all —some, among the woodwinds in the back, whisper and giggle about their own private matters. \"Mr. Payton,\" Frank says. \"I need some "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("erl.\" ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA87"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA87.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA87.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA87"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.88.1.0.box.177.255.1374.2189.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA87.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.88.1.0.box.178.255.1367.111.q.50"
    }
  }, [_vm._v("Mr. Payton puts on a quizzical, confounded expression. \"Whatchu say, son? Whatchu need?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA87.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.88.1.1.box.229.383.574.47.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA87.w.1.1.0"
    }
  }), _vm._v("\"Some "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("erl. ")]), _vm._v("For my trumpet.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA87.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.88.1.2.box.229.445.851.48.q.70"
    }
  }, [_vm._v("\"Whatchu talkin' 'bout? For your "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("valves?\" ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA87.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.88.1.3.box.228.509.175.35.q.101"
    }
  }, [_vm._v("\"Yessir.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA87.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.88.1.4.box.229.572.1235.47.q.40"
    }
  }, [_vm._v("\"What's this about "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("'erl'? ")]), _vm._v("Boy, you mean "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("awl. ")]), _vm._v("Say it. Say "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("awl.\" ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA87.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.88.1.5.box.232.635.505.40.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"Orl,")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\" ")]), _vm._v("Frank tries it, "), _c('i', [_vm._v("\"Col. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\" ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA87.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.88.1.6.box.177.698.1371.173.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA87.w.1.2.0"
    }
  }), _vm._v("Mr. Payton reaches in another guayabera pocket and hands Frank a little plastic bottle of valve oil. Frank oils his valves and hands it back, clicking his fingers over the keys.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA87.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.88.1.7.box.229.887.960.48.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA87.w.1.3.0"
    }
  }), _vm._v("\"OK, now,\" Mr. Payton says, raising his finger.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA87.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.88.1.8.box.178.951.1371.730.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA87.w.1.4.0"
    }
  }), _vm._v("Now Frank succeeds at executing the opening solo notes of the \"Second Line,\" and the rest of the band comes in with the melody and lurches forward on their feet. The drum corps at the rear creeps the tempo forward until Mr. Payton shouts their names and holds up his hand. They seem to know what he means: slow down. The amble continues into the narrow walkway leading from the rear playground to the parking lot to the right of the school building. This alley is always a shady canyon, sandwiched between the high walls of the school and of the close-pressed homes behind. Mr. Payton has turned to face forward and is walking with an exaggerated swagger in the hopes that the band will take their pace from him.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA87.w.1.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.88.1.9.box.178.1710.1372.299.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA87.w.1.5.0"
    }
  }), _vm._v("But another group of kids comes up the alleyway from the other direction. They don't seem to be accompanied by a teacher. They're making music, too. Beating broomsticks on cardboard boxes, pencils and pens on bottles and cans, slamming books together, and singing. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"Hey. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Hey ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hey ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hey. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Hey ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Pocky ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Way.")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\" ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA87.w.1.10.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.88.1.10.box.178.2022.1373.422.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA87.w.1.6.0"
    }
  }), _vm._v("\"Wait a minute, now, whoa, hold up, the band's coming through here.\" Mr. Payton turns and signals to the band to stop. Then he turns to the troop of boys marching in the other direction. \"Hey now, hold up. Where y'all supposed to be?\" The apparent leader of the singing bunch is shirtless. He sings the loudest, switching his eye contact back and forth between Mr. Payton and the boys and girls behind him. But they keep coming on, wash past Mr. Payton,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA88.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.89.1.0.box.178.249.1369.111.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA88"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA88.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA88.w.1.0.0"
    }
  }), _vm._v("\nand start cutting through the ranks of the band. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"Hey!\" ")]), _vm._v("they halfshout, half-sing. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"Hey ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hey ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hey. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Hey ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Pocky ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Way.")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\" ")])])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA88.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA88.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA88.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA88"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.89.1.0.box.177.249.1372.301.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA88.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.89.1.1.box.177.377.1372.173.q.50"
    }
  }, [_vm._v("\"OK, OK,\" Mr. Pay ton says, calling Frank's name and a few others, attempting to corral his band. \"C'mon now, let 'em through. Let the Indians through.\"")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.89.2.0.box.1281.631.265.33.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA88.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.89.2.0.box.1281.631.265.33.q.70"
    }
  }, [_vm._v("C. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("W. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cannon ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA89"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA89.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA89.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA89"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.90.1.0.box.177.264.1373.1789.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA89.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.90.1.0.box.178.264.320.88.q.50"
    }
  }, [_vm._v("2:55 P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA89.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.90.1.1.box.177.445.261.40.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA89.w.2.0.0"
    }
  }), _vm._v("Dear ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps",
      "font-style": "italic"
    }
  }, [_vm._v("Editor, ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA89.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.90.1.2.box.177.570.1371.110.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA89.w.3.0.0"
    }
  }), _vm._v("Feel ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("free ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("edit ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("this, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("or ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("rewrite ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("it ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("entirely. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("I ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("just ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("thought ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("incident ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("should ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("not ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pass ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("unheralded. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA89.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.90.1.3.box.179.761.407.46.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA89.w.4.0.0"
    }
  }), _vm._v("Thanks, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Gary ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Thomas ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA89.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.90.1.4.box.177.887.1371.224.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA89.w.5.0.0"
    }
  }), _vm._v("We are not wannabe suicide bombers in the Sportsman's Paradise that is Northeast Louisiana. When we lose a limb to an explosive device of our own manufacture, it is accidental and occurs in the course of innocent merriment.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA89.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.90.1.5.box.177.1139.1371.427.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA89.w.5.1.0"
    }
  }), _vm._v("Consider Shane Hays, twenty-six, of Tallulah, as he and his brother-in-law embark on a Saturday-afternoon fishing expedition on a private pond in Madison Parish. The fish are uncooperative, but our intrepid pair is not deterred. Shane, you see, is prepared, thanks to a pipe bomb built from a recipe he got off the Internet. It's to stun the fish and bring them to the surface, like the miracle in St. Luke's Gospel.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA89.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.90.1.6.box.178.1582.1370.299.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA89.w.5.2.0"
    }
  }), _vm._v("The detonation, alas, is premature, and our hero loses his good right hand, although both he and his brother-in-law survive. Shane is young and will easily learn to use his left hand to repair the small engines he works on. And what a story for the grandchildren he'll have someday!")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA89.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.90.1.7.box.178.1897.1372.156.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA89.w.5.3.0"
    }
  }), _vm._v("Bethany Bultman knows whereof she speaks when she writes of the motto/epitaph of the Northeast Louisiana redneck: \"Watch this!\"")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA90"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA90.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA90.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA90.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA90.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA90"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.91.1.0.box.178.274.1371.2162.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA90.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.91.1.0.box.180.274.318.88.q.50"
    }
  }, [_vm._v("2:59 P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA90.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.91.1.1.box.178.454.1369.172.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("He ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Stomps ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Into ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Tiny ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Office ")]), _vm._v("as he does every Wednesday, heads straight for the digital clock sitting atop her desk, and reads the large squared red numbers in a gruff voice:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA90.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.91.1.2.box.178.643.1370.98.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA90.w.2.1.0"
    }
  }), _vm._v("\"Two, five, nine. One minute, not my time yet. You can't write it down. That's the rules.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA90.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.91.1.3.box.178.770.1369.299.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA90.w.2.2.0"
    }
  }), _vm._v("He looks at the blueberry candle burning its cloyingly sweet perfume on the desk and swivels to sternly glare at her sitting crosslegged on the floor. He climbs up on her desk chair and leans forward to blow out the candle in one f"), _c('a', {
    attrs: {
      "id": "GBS.PA90.w.2.3.0"
    }
  }), _vm._v("orceful puff of air. I told you a'fore. Keep that out.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA90.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.91.1.4.box.178.1085.1369.110.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA90.w.2.4.0"
    }
  }), _vm._v("I'm sorry. I should have blown it out before you got here. The big people like it. It makes them feel safe. That wasn't fair of me.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA90.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.91.1.5.box.179.1211.1368.109.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA90.w.2.5.0"
    }
  }), _vm._v("He climbs down off of the chair and trudges toward her. Squats down until he is eye level with her.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA90.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.91.1.6.box.178.1335.1370.297.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA90.w.2.6.0"
    }
  }), _vm._v("\"The big people don't know nothing 'bout the matches making the shrimp nets go to fire from the gasoline and John still is very alone on the boat 'cause Daddy got new nets right when John's arm got broke. John says better just hurry get the shrimps out the nets off the boat fast, bye, bye, bye.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA90.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.91.1.7.box.229.1648.1127.47.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA90.w.2.7.0"
    }
  }), _vm._v("\"You're right. I should get rid of the blueberry candle.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA90.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.91.1.8.box.229.1710.1093.47.q.50"
    }
  }, [_vm._v("\"I'm a half-trawler, but my daddy, he's a whole one.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA90.w.1.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.91.1.9.box.178.1773.1371.349.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA90.w.2.8.0"
    }
  }), _vm._v("He stands up, digs his white rubber shrimping boot into the blue threadbare carpet, spins on his heel, and plants his other bare foot in front of him to march back to the door. He pulls it shut and reaches up to hurriedly turn the deadbolt perched just above the knob three times before locking the door, counting out loud with each turn of the lock.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA90.w.1.10.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.91.1.10.box.178.2151.1371.235.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA90.w.2.9.0"
    }
  }), _vm._v("He stands at the door staring up at the map of Louisiana dotted with rape crisis centers tacked beside the knob. He reaches up and stabs the tiny house marked by the word "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Houma, ")]), _vm._v("encircled by a child's crayoned lopsided heart.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA90.w.1.11.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.91.1.11.box.251.2402.505.34.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA90.w.2.10.0"
    }
  }), _vm._v("\"Where is that?\" she asks.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA91"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA91.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA91.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA91"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.92.1.0.box.177.254.1373.1875.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA91.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.92.1.0.box.229.254.965.35.q.60"
    }
  }, [_vm._v("His words hush out of his mouth in a susurrus.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA91.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.92.1.1.box.179.318.1369.161.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA91.w.1.1.0"
    }
  }), _vm._v("\"Shhhhh. None the baby gators can swim in John's mouth in the heart house, none the baby gators can swim in hearts, everybody knows.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA91.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.92.1.2.box.178.507.1370.112.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA91.w.1.2.0"
    }
  }), _vm._v("He opens and closes his mouth rapidly like a catfish, chopping his teeth loudly together upon each closure.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA91.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.92.1.3.box.179.635.1369.111.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA91.w.1.3.0"
    }
  }), _vm._v("\"John never was choking in this house, not one time in the dayshine.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA91.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.92.1.4.box.178.762.1370.110.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA91.w.1.4.0"
    }
  }), _vm._v("He turns on his heels again in his military fashion and stomps over to her where she sits amidst cans of Play-Doh.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA91.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.92.1.5.box.177.887.1372.287.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA91.w.1.5.0"
    }
  }), _vm._v("He digs his hand into the front pocket of his overall shorts. His bare chest exposes a clean count of four blue fingertips along the clavicle peeking out from the fold in the blue jean where the right strap hangs loose. He pulls out a bundle of paper towels and shoves his hand at her.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA91.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.92.1.6.box.229.1203.329.33.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA91.w.1.6.0"
    }
  }), _vm._v("\"Is this for me?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA91.w.1.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.92.1.7.box.229.1265.866.48.q.60"
    }
  }, [_vm._v("\"Not from me. John wants you to have it.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA91.w.1.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.92.1.8.box.178.1330.1371.362.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA91.w.1.7.0"
    }
  }), _vm._v("She unwinds the loops of carefully wrapped paper towels and uncovers a small blue crab, perfectly intact and cleaned out, carrying only the slightest scent of the Gulf Coast waters down the bayou. She holds it delicately in her hands as she speaks, working her fingertips over the ten blue pinching claws folded in precision around the body and poised as if to snap in front of the mouth.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA91.w.1.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.92.1.9.box.229.1709.906.47.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA91.w.1.8.0"
    }
  }), _vm._v("\"It's so clean. How did John get it so clean?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA91.w.1.10.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.92.1.10.box.180.1772.1370.97.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA91.w.1.9.0"
    }
  }), _vm._v("\"Ants. He put it in the ants after trawling on the boat. Came out the nets.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA91.w.1.11.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.92.1.11.box.229.1899.715.41.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA91.w.1.10.0"
    }
  }), _vm._v("\"Where is John? Can I thank him?\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA91.w.1.12.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.92.1.12.box.229.1961.433.32.q.70"
    }
  }, [_vm._v("He looks at the clock.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA91.w.1.13.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.92.1.13.box.229.2020.1204.48.q.60"
    }
  }, [_vm._v("\"Three, zero, zero. My time now. No more words for you.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA91.w.1.14.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.92.1.14.box.229.2083.1029.46.q.60"
    }
  }, [_vm._v("He reaches out his hands for the cans of Play-Doh.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.92.2.0.box.1298.2210.252.46.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA91.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.92.2.0.box.1298.2210.252.46.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA91.w.2.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Lee ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Barclay ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA92"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA92.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA92.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA92.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA92.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA92"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.93.1.0.box.178.278.1378.2174.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA92.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.93.1.0.box.180.278.320.88.q.60"
    }
  }, [_vm._v("3:07 P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA92.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.93.1.1.box.178.455.1373.548.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Young ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Woman ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Is ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Visiting ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Cemetery ")]), _vm._v("of Grace Episcopal Church in St. Francisville with her father, a tombstone conservator. They are here to repair Grace's gravestones, which have slowly been decaying over the years from the pollution coming from chemical plants up the Mississippi River. It is a brick church, built in 1827, with gothic windows, settled in the shade of oak trees covered in Spanish moss. A wrought-iron fence surrounds the grounds. It seems more like a church you'd find in the countryside of England or France, or so she thinks.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA92.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.93.1.2.box.182.1023.1369.300.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA92.w.2.1.0"
    }
  }), _vm._v("Her father scrapes moss off an angel with a chipped wing, then taps and measures a cracked mausoleum belonging to the Gilbert family. She walks the grounds, the pathways through the trees, and peers into the church through the keyhole in the front door. She finds the door unlocked and pushes it open.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA92.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.93.1.3.box.182.1335.1372.478.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA92.w.2.2.0"
    }
  }), _vm._v("She walks down the aisle, through colored shadows of stainedglass windows, toward dried magnolia leaves left on the altar. A marble baptismal font is in the corner, an angel holding its basin carefully with outstretched arms. The angel has a look on its face of steadiness and strength and its features are simple, unlike the ornate angels in the churchyard. Normally she did not particularly care for angels but this one she likes. She realizes that this is the place where she will be married.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA92.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.93.1.4.box.184.1838.1370.163.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA92.w.2.3.0"
    }
  }), _vm._v("She looks up at the arches in the ceiling, knowing this fact, and then the iron lanterns that hang from it, knowing it. Even the angel knows.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA92.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.93.1.5.box.185.2026.1370.364.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA92.w.2.4.0"
    }
  }), _vm._v("She is still many years from the age of marriage but she holds the thought in her mind, like the angel its basin, imagining walking through the churchyard in a wispy, long dress and carrying lilies from her mother's garden. She walks down the aisle with her father, dressed in his best summer suit, his white linen one. There would be a small picnic party for her family on the riverbank afterward.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA92.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.93.1.6.box.236.2404.1320.48.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA92.w.2.5.0"
    }
  }), _vm._v("When she reaches the altar the fantasy stops. She can't fill in the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA93.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.94.1.0.box.177.255.1372.160.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA93"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA93.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA93.w.1.0.0"
    }
  }), _vm._v("\npicture anymore because she can't imagine the husband to be. She can't even make him into a blur temporarily, for the sake of the daydream.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA93.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA93"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.94.1.0.box.177.255.1372.362.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA93.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.94.1.1.box.177.444.1372.173.q.70"
    }
  }, [_vm._v("She forgets these thoughts about her marriage, not even really aware of the obstacle to them, and goes back to the churchyard to help her father with the tombstones.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.94.2.0.box.1227.700.323.34.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA93.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.94.2.0.box.1227.700.323.34.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA93.w.2.0.0"
    }
  }), _vm._v("- ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Minter ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Krotzer ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA94"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA94.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA94.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA94.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA94.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA94"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.95.1.0.box.177.266.1373.1485.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA94.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.95.1.0.box.180.266.306.88.q.60"
    }
  }, [_vm._v("3:12 P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA94.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.95.1.1.box.177.447.1373.426.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Old ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Man ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Sits ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("On ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Porch ")]), _vm._v("of his country home in Paulina, with his hound dog, Perique, by his side. It is the sugarcane harvest, a very busy time of the year. They have burned the fields, once brilliant green as far as the eye can see. The wagons are lined up along the road waiting to haul the cane to the refinery down in Gramercy. He looks forward to the harvest. With all the activity, the days are not so long.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA94.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.95.1.2.box.178.889.1371.362.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA94.w.2.1.0"
    }
  }), _vm._v("The old man crosses the dusty road to the fields to cut a few stalks. He brings them home and stands them on the porch. Later, when his company comes, he will pull out his favorite knife and peel back the outer layer of the cane, slicing the sweet sugar chew to share. A custom passed on through the generations, the chew and the memories it brings are still sweet.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA94.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.95.1.3.box.178.1267.1372.295.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA94.w.2.2.0"
    }
  }), _vm._v("His granddaughter attends LSU, where her parents met as students. They've come down for the big game and to visit with him. Since Mama passed, they have begged Papa to come live with them. But he can't leave his home. He was born here. Besides, he is content with his constant companion, Perique.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA94.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.95.1.4.box.179.1578.1371.173.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA94.w.2.3.0"
    }
  }), _vm._v("So, he sits and waits for the visit, looking out across the sugarcane fields to blue skies and white billowing clouds. Season to season, he watches the sugarcane grow, and he awaits the harvest.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.95.2.0.box.1146.1831.404.33.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA94.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.95.2.0.box.1146.1831.404.33.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA94.w.3.0.0"
    }
  }), _vm._v("Lina ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Hutches ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Beavers ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA95"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.96.1.0.box.176.262.1375.1984.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA95.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.96.1.0.box.182.262.304.88.q.40"
    }
  }, [_vm._v("3:15P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA95.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.96.1.1.box.179.444.1321.46.q.70"
    }
  }, [_vm._v("His "), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Heart ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Knew ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Much ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Earlier ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Than ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("He ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Did ")]), _c('a', {
    attrs: {
      "id": "GBS.PA95"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA95.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA95.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA95.w.2.0.0"
    }
  }), _vm._v("that the past was lost.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA95.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.96.1.2.box.178.506.1372.351.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA95.w.2.1.0"
    }
  }), _vm._v("He used to sit on this stair landing, listening to the sleepers of the house, to the susurrus of their dreaming lips, and he'd well with sadness for his children's impending passage into adolescence, adulthood. Even now he still dreams of each child as a youngster — no matter how angular and rough-chinned a man or how lithesome a woman.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA95.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.96.1.3.box.177.886.1374.237.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA95.w.2.2.0"
    }
  }), _vm._v("His walk through the gutted house, freed of the tangled mass of his moldy and shattered family life, in a neighborhood without neighbors, brought back the taste of other losses, which appeasing memory had rendered bland and indistinct.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA95.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.96.1.4.box.177.1139.1373.728.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA95.w.2.3.0"
    }
  }), _vm._v("His mother was old, and it could be said that she had lived a good long life. A half-truth that he shouldn't have relied upon, yet did. And his father died fifteen years earlier, sedated to ease his slow, painful sinkage into nonbeing. Nonbeing plainly demarked with one last agonal breath. And his mother, off life-support systems, which had bruised her arms and scratched her trachea, faded behind her old frightened eyes and receded into death. He had placed his hand on her forehead and whispered that she should remember how much the grandchildren loved her and how much fun they had together on their family trips to exotic places: Rome, Paris, Amsterdam. \"Remember,\" he faltered. \"Remember how much fun we had.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA95.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.96.1.5.box.228.1896.1085.35.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA95.w.2.4.0"
    }
  }), _vm._v("What did she hear? he wonders. What did she think?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA95.w.1.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.96.1.6.box.176.1958.1372.288.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA95.w.2.5.0"
    }
  }), _vm._v("He's hot in his disposable coveralls, rubber gloves, and respirator. His glasses are fogged beneath his goggles. He removes the goggles, mask, and gloves. His hands, starting to spot with age, resemble his father's big-knuckled ones. His fingers, so much like his father's, touch his forehead, but he feels his mother's.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.96.2.0.box.1220.2335.328.45.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA95.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.96.2.0.box.1220.2335.328.45.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA95.w.3.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Wayne ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("McGaw ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA96"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA96.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA96.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA96.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA96.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA96"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.97.1.0.box.177.256.1373.1985.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA96.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.97.1.0.box.180.256.324.88.q.50"
    }
  }, [_vm._v("3:22 P.M.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA96.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.97.1.1.box.177.435.1372.666.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("He ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Wears ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("An ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Olive-green ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Army ")]), _c('span', {
    staticStyle: {
      "font-variant": "small-caps"
    }
  }, [_vm._v("Jacket ")]), _vm._v("with a Purple Heart pinned above his name. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Arceneaux ")]), _vm._v("is stenciled in military lettering, black, crude, like the heading on a kid's science project. Shadows of longgone sergeant stripes still show on the sleeves. Motor-oil stains seep like wounds through the material. His pants are filthy workman's khaki, cuffed but frayed. Military dress shoes are highly polished and black as ink. The right pant leg is gathered and cinched in the jaws of a dog collar to protect it from a missing chain guard on his bicycle. His hair is gray and short, not disciplined enough to be a flattop, but longer than a burr. Scars cover his face, some too deep to be from acne.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA96.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.97.1.2.box.177.1129.1372.173.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA96.w.2.1.0"
    }
  }), _vm._v("He dismounts the bike, engages the kick stand, and scans the area in front of the convenience store. Located in Port Allen, the store is just a width-of-the-Mississippi River away from the state capitol.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA96.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.97.1.3.box.179.1317.1371.673.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA96.w.2.2.0"
    }
  }), _vm._v("Customers, filling their tanks, provide cover and diversion from the watchful eyes of the Vietnamese clerk inside the store. Timing is right; his mission is a go. He crouches behind a blue trash barrel that smells like road kill and proceeds to rifle through its contents, separating crawfish heads, half-eaten fish sandwiches, and napkins soaked in ketchup from other, more valuable, items. Flies swarm, land, and retreat from his swatting hand, only to land again. Extracting aluminum cans of Budweiser, Coke, A&W, Pepsi, and Red Bull, he drains, crushes, and squeezes the cans into a plastic bag. Heavy, worthless glass bottles of Dixie and Abita Beer are quietly returned to the barrel.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA96.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.97.1.4.box.179.2005.1371.236.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA96.w.2.3.0"
    }
  }), _vm._v("Within seconds, he loads the half-filled bag into a Red Flyer wagon attached by a rawhide strap to the seat post of the bicycle and pedals onto the shoulder of Highway 415 and then onto Interstate 10. The next exit is eight miles away.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.97.2.0.box.1286.2320.265.34.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA96.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "id": "para.97.2.0.box.1286.2320.265.34.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA96.w.3.0.0"
    }
  }), _vm._v("- "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Mark ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("David ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA97"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA97.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA97.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA97.w.1.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b1b27f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0007.vue
// module id = 57
// module chunks = 0